<template>
  <div class="container">
    <div class="row">
      <div v-if="locale === 'dk'">
        <h1 class="page-title">Ofte Stillede Spørgsmål</h1>
        <ul ref="list" class="list">
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Hvilke betingelser skal jeg opfylde for at kunne deltage i
                Oral-B penge-tilbage-garanti?
              </p>
            </div>
            <div class="list-item-details">
              <ul>
                <li>Minimumsalder: Du skal være mindst 18 år gammel.</li>
                <li>
                  Bopæl: Du skal have bopæl i Norge, Danmark, Sverige og
                  Finland.
                </li>
                <li>
                  Bankoplysninger: Du skal have et IBAN-nummer, der tilhører et
                  europæisk land.
                </li>
                <li>
                  E-mailadresse: Du kan kun deltage med din egen e-mail-adresse.
                </li>
              </ul>
              <p>
                Bemærk: Hvert IBAN og hver e-mail-adresse er kombineret til en
                brugerkonto og kan kun deltage i hele kampagnen i én enkelt
                kombination.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hvordan kan jeg deltage i Oral-B penge-tilbage-garanti?</p>
            </div>
            <div class="list-item-details">
              <p>
                Du kan kun deltage online - via kampagnens websted
                <a href="https://www.oral-b-moneyback.com/dk"
                  >www.oral-b-moneyback.com</a
                >. Processen kan beskrives som følger:
              </p>
              <ul>
                <li>angive salgsfremmende produktet,</li>
                <li>lav et foto af dit købsbevis og upload det,</li>
                <li>
                  upload et foto af dit Oral-B produkt (du skal sørge for, at
                  stregkoden på dit salgsfremmende produkt er tydeligt synlig),
                </li>
                <li>
                  indtaste bankoplysninger (IBAN), e-mail-adresse og andre
                  personlige oplysninger,
                </li>
                <li>acceptere vilkår for deltagelse + privatlivspolitik.</li>
              </ul>
              <p>
                Når du har modtaget en bekræftelse på din online-registrering,
                skal du sende produktet sammen med den tilsvarende kupon til
                servicecentret inden for <strong>10 dage</strong>. Du vil
                modtage din refusion inden for 6 uger efter, at pakken er
                ankommet og bekræftet i servicecentret.
              </p>
              <p>
                Bemærk: Det er ikke muligt at bruge forskellige e-mail-adresser
                (brugerkonti) pr. person.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hvor skal jeg sende pakken med produktet hen?</p>
            </div>
            <div class="list-item-details">
              <p>
                Send venligst dit produkt sammen med returformularen og en kopi
                af dit købsbevis til et af følgende P&amp;G servicecentre:
              </p>
              <p><strong>Norge</strong></p>
              <p>L.G. Elektro A/S</p>
              <p>Kolstien 4</p>
              <p>5097 Bergen</p>
              <p>Norge</p>
              <p><strong>Sverige</strong></p>
              <p>
                El &amp; Digital Service AB<br />Folkungagatan 144<br />116 30
                Stockholm<br />Sverige
              </p>
              <p><strong>Finland</strong></p>
              <p>AIDE Europe Oy</p>
              <p>Haukilahdenkatu 4</p>
              <p>FI-00550 Helsinki</p>
              <p>Suomi</p>
              <p><strong>Danmark</strong></p>
              <p>
                CJ Hvidevareservice<br />Thorndahlsvej 11<br />9200 Aalborg
                SV<br />Danmark
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Hvem skal jeg kontakte, hvis jeg har spørgsmål om Oral-B
                penge-tilbage-garanti?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                <br />Kontakt venligst Oral-B penge-tilbage-garanti kundeservice
                via
                <a href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Hvilke produkter skal jeg købe for at kunne deltage i Oral-B
                penge-tilbage-garanti?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                <br /><br />Følgende produkter deltager i Oral-B
                penge-tilbage-garanti:<br /><br /><br />
              </p>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <p>Oral-B Laboratory Clean 1</p>
                    </td>
                    <td>
                      <p>4210201238331</p>
                    </td>
                    <td>
                      <p>Oral-B iO8 S Black UCB</p>
                    </td>
                    <td>
                      <p>4210201307327</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Laboratory Clean 3</p>
                    </td>
                    <td>
                      <p>4210201291947</p>
                    </td>
                    <td>
                      <p>Oral-B iO8 S Violet UC</p>
                    </td>
                    <td>
                      <p>4210201307389</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Laboratory Clean 5</p>
                    </td>
                    <td>
                      <p>4210201238492</p>
                    </td>
                    <td>
                      <p>Oral-B iO9 S White UC</p>
                    </td>
                    <td>
                      <p>4210201307556</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality100 Kids Frozen Hbox + TC</p>
                    </td>
                    <td>
                      <p>4210201309512</p>
                    </td>
                    <td>
                      <p>Oral-B iO9 S Black UCB</p>
                    </td>
                    <td>
                      <p>4210201307594</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality Kids Spiderman CLS</p>
                    </td>
                    <td>
                      <p>4210201320074</p>
                    </td>
                    <td>
                      <p>Oral-B iO9 S Rose Quartz UC</p>
                    </td>
                    <td>
                      <p>4210201307631</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality100 Kids Mandalorian CLS</p>
                    </td>
                    <td>
                      <p>4210201386230</p>
                    </td>
                    <td>
                      <p>Oral-B iO8 Duo White UC / Black UC</p>
                    </td>
                    <td>
                      <p>4210201315766</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality100 Kids Starwars Hbox + TC</p>
                    </td>
                    <td>
                      <p>4210201309444</p>
                    </td>
                    <td>
                      <p>Oral-B iO6 White UC</p>
                    </td>
                    <td>
                      <p>4210201377665</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality100 Kids Star wars CLS</p>
                    </td>
                    <td>
                      <p>4210201241201</p>
                    </td>
                    <td>
                      <p>Oral-B iO6 Grey Opal UC</p>
                    </td>
                    <td>
                      <p>4210201377788</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality100 Kids Frozen CLS</p>
                    </td>
                    <td>
                      <p>4210201241317</p>
                    </td>
                    <td>
                      <p>Oral-B iO6 Pink Sand GC</p>
                    </td>
                    <td>
                      <p>4210201378143</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality100 Kids Starwars Hbox</p>
                    </td>
                    <td>
                      <p>4210201241331</p>
                    </td>
                    <td>
                      <p>Oral-B iO6 Duo White UC / Pink UC</p>
                    </td>
                    <td>
                      <p>4210201378198</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Kids D12 Starter Pack Star Wars</p>
                    </td>
                    <td>
                      <p>4210201307105</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2 2400N Black SUT</p>
                    </td>
                    <td>
                      <p>4210201258117</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Kids D12 Starter Pack Frozen</p>
                    </td>
                    <td>
                      <p>4210201307242</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2 2400N Pink SUT</p>
                    </td>
                    <td>
                      <p>4210201258544</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Starter Pack Turquiose CA</p>
                    </td>
                    <td>
                      <p>4210201260899</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2 2300W White SUT</p>
                    </td>
                    <td>
                      <p>4210201258643</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality100 Kids Frozen Hbox</p>
                    </td>
                    <td>
                      <p>4210201241379</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2 2200S Blue SUT</p>
                    </td>
                    <td>
                      <p>4210201274681</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 680 White CA</p>
                    </td>
                    <td>
                      <p>4210201235811</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2900 Black CA</p>
                    </td>
                    <td>
                      <p>4210201271598</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 3 Junior Star Wars Sens</p>
                    </td>
                    <td>
                      <p>4210201396109</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2700 Blue CA</p>
                    </td>
                    <td>
                      <p>4210201179078</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 3 Junior Minnie Sens</p>
                    </td>
                    <td>
                      <p>4210201396123</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2000 White SUT</p>
                    </td>
                    <td>
                      <p>4210201249924</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3400N Black CA</p>
                    </td>
                    <td>
                      <p>4210201291053</p>
                    </td>
                    <td>
                      <p>Oral-B Pro2 2500 Black CA Black</p>
                    </td>
                    <td>
                      <p>4210201319412</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3400N Pink Sensi</p>
                    </td>
                    <td>
                      <p>4210201291077</p>
                    </td>
                    <td>
                      <p>Oral-B Pro2 2500 Pink 3DW</p>
                    </td>
                    <td>
                      <p>4210201319313</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3200S Blue Sensi</p>
                    </td>
                    <td>
                      <p>4210201291091</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2000 Blue CA</p>
                    </td>
                    <td>
                      <p>4210201178682</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3000 PureClean</p>
                    </td>
                    <td>
                      <p>4210201365280</p>
                    </td>
                    <td>
                      <p>Oral-B Oral B Clean &amp; Protect Pro 2 Black CA</p>
                    </td>
                    <td>
                      <p>4210201396000</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3300W White Sensi</p>
                    </td>
                    <td>
                      <p>4210201291114</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2 2000 Black CA Black</p>
                    </td>
                    <td>
                      <p>4210201267782</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 890 White SUT</p>
                    </td>
                    <td>
                      <p>4210201235941</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2 2000 Pink CA</p>
                    </td>
                    <td>
                      <p>4210201178736</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3900N White Sens +Black Sens</p>
                    </td>
                    <td>
                      <p>4210201291503</p>
                    </td>
                    <td>
                      <p>Oral-B iO 6N Black UCB</p>
                    </td>
                    <td>
                      <p>4210201409113</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3950N Black CA + Pink CA</p>
                    </td>
                    <td>
                      <p>4210201291374</p>
                    </td>
                    <td>
                      <p>Oral-B iO7 N White UC</p>
                    </td>
                    <td>
                      <p>4210201307181</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Smart 4 4900 White SUT</p>
                    </td>
                    <td>
                      <p>4210201271611</p>
                    </td>
                    <td>
                      <p>Oral-B iO8 SE Black UC + Pouch</p>
                    </td>
                    <td>
                      <p>4210201307433</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Genius X 20400N Black CA Black</p>
                    </td>
                    <td>
                      <p>4210201272922</p>
                    </td>
                    <td>
                      <p>Oral-B iO8 SE Violet UC + Pouch</p>
                    </td>
                    <td>
                      <p>4210201307464</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Genius X 20300W White SUT</p>
                    </td>
                    <td>
                      <p>4210201276869</p>
                    </td>
                    <td>
                      <p>Oral-B iO9 N Black UCB</p>
                    </td>
                    <td>
                      <p>4210201307570</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Genius X 20200S RoseGold SUT</p>
                    </td>
                    <td>
                      <p>4210201274858</p>
                    </td>
                    <td>
                      <p>Oral-B iO9 N RoseQuartz UC</p>
                    </td>
                    <td>
                      <p>4210201307617</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality 100 White CA CLS</p>
                    </td>
                    <td>
                      <p>4210201199441</p>
                    </td>
                    <td>
                      <p>Oral-B iO9 N White UC</p>
                    </td>
                    <td>
                      <p>4210201307532</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality 100 White CA HB</p>
                    </td>
                    <td>
                      <p>4210201199472</p>
                    </td>
                    <td>
                      <p>Oral-B iO6 Duo Black UC / Pink UC</p>
                    </td>
                    <td>
                      <p>4210201411536</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality 170 Blue CA HB</p>
                    </td>
                    <td>
                      <p>4210201201038</p>
                    </td>
                    <td>
                      <p>Oral-B iO9 Duo Black UC / Rose Quartz UC</p>
                    </td>
                    <td>
                      <p>4210201411550</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Junior Green SUT</p>
                    </td>
                    <td>
                      <p>4210201202318</p>
                    </td>
                    <td>
                      <p>Oral-B PROFESSIONAL GUM CARE 1</p>
                    </td>
                    <td>
                      <p>4210201238355</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Junior Purple SUT</p>
                    </td>
                    <td>
                      <p>4210201202332</p>
                    </td>
                    <td>
                      <p>Oral-B PROFESSIONAL GUM CARE 2</p>
                    </td>
                    <td>
                      <p>4210201238454</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 760 Black CA</p>
                    </td>
                    <td>
                      <p>4210201137191</p>
                    </td>
                    <td>
                      <p>Oral-B PROFESSIONAL GUM CARE 3</p>
                    </td>
                    <td>
                      <p>4210201238515</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 700 Turquoise CA</p>
                    </td>
                    <td>
                      <p>4210201124092</p>
                    </td>
                    <td>
                      <p>Oral-B PROFESSIONAL GENIUS 10 GUM CARE</p>
                    </td>
                    <td>
                      <p>4210201271864</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 700 White SUT</p>
                    </td>
                    <td>
                      <p>4210201157786</p>
                    </td>
                    <td>
                      <p>Oral-B Vitality100 Kids Pixar Hbox + TC</p>
                    </td>
                    <td>
                      <p>4210201314592</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 750 Black CA Black</p>
                    </td>
                    <td>
                      <p>4210201319399</p>
                    </td>
                    <td>
                      <p>Oral-B Vitality 150 White CA HB</p>
                    </td>
                    <td>
                      <p>4210201200772</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 750 Pink 3DW</p>
                    </td>
                    <td>
                      <p>4210201312499</p>
                    </td>
                    <td>
                      <p>Oral-B Junior D501 Star Wars SUT</p>
                    </td>
                    <td>
                      <p>4210201245780</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro1 750 White CA</p>
                    </td>
                    <td>
                      <p>4210201312291</p>
                    </td>
                    <td>
                      <p>Oral-B Junior D501 Minnie SUT</p>
                    </td>
                    <td>
                      <p>4210201245896</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 800 White SUT</p>
                    </td>
                    <td>
                      <p>4210201077596</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 4 4400N White SUT</p>
                    </td>
                    <td>
                      <p>4210201255277</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 900 White SUT</p>
                    </td>
                    <td>
                      <p>4210201187370</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 4 4200S White CA</p>
                    </td>
                    <td>
                      <p>4210201274728</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3700 CA</p>
                    </td>
                    <td>
                      <p>4210201291176</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 5000N White CA</p>
                    </td>
                    <td>
                      <p>4210201203315</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 3 3000 CA Black Edition</p>
                    </td>
                    <td>
                      <p>4210201289364</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 5 5400N White SUT</p>
                    </td>
                    <td>
                      <p>4210201255499</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3000 White Sensi</p>
                    </td>
                    <td>
                      <p>4210201289470</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 5 5200S White CA</p>
                    </td>
                    <td>
                      <p>4210201274773</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3500 Black CA Black</p>
                    </td>
                    <td>
                      <p>4210201289517</p>
                    </td>
                    <td>
                      <p>Oral-B GENIUS 8 8100S WHITE SU</p>
                    </td>
                    <td>
                      <p>4210201261414</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3500 WT Sensi</p>
                    </td>
                    <td>
                      <p>4210201289562</p>
                    </td>
                    <td>
                      <p>Oral-B Genius X 20100S Blush Pink SUT</p>
                    </td>
                    <td>
                      <p>4210201279785</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 970 White CA</p>
                    </td>
                    <td>
                      <p>4210201207955</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 4 4000N White CA</p>
                    </td>
                    <td>
                      <p>4210201203377</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Smart Sensitive White Sensi</p>
                    </td>
                    <td>
                      <p>4210201396697</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 4 4500 3DW</p>
                    </td>
                    <td>
                      <p>4210201312536</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Smart Sensitive WT Sensi + TC</p>
                    </td>
                    <td>
                      <p>4210201396673</p>
                    </td>
                    <td>
                      <p>Oral-B Genius 8600 Silver SUT</p>
                    </td>
                    <td>
                      <p>4210201261506</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Smart 5 5900 Black + White CA</p>
                    </td>
                    <td>
                      <p>4210201180074</p>
                    </td>
                    <td>
                      <p>Oral-B Genius 8500 Silver CA</p>
                    </td>
                    <td>
                      <p>4210201314530</p>
                    </td>
                  </tr>
                  <tr></tr>
                  <tr>
                    <td>
                      <p>Oral-B Genius X 20100S Black CA BK</p>
                    </td>
                    <td>
                      <p>4210201247357</p>
                    </td>
                    <td>
                      <p>Oral-B Genius 8900 Silver CA + Silver 3DW</p>
                    </td>
                    <td>
                      <p>4210201157601</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Genius X 20900 RoseG SUT/Black CA Black</p>
                    </td>
                    <td>
                      <p>4210201276982</p>
                    </td>
                    <td>
                      <p>Oral-B Genius X 20100S White SUT</p>
                    </td>
                    <td>
                      <p>4210201247166</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality 100 Pink CA HB</p>
                    </td>
                    <td>
                      <p>4210201200710</p>
                    </td>
                    <td>
                      <p>Oral-B Genius X Blush Pink SUT Art of Brushing</p>
                    </td>
                    <td>
                      <p>4210201295358</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality 100 Black CA HB</p>
                    </td>
                    <td>
                      <p>4210201200758</p>
                    </td>
                    <td>
                      <p>Oral-B Genius X Black CA Black Art of Brushing</p>
                    </td>
                    <td>
                      <p>4210201295402</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B iO7 S White UC</p>
                    </td>
                    <td>
                      <p>4210201306702</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 6 6600 Blue CA</p>
                    </td>
                    <td>
                      <p>4210201203292</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B iO7S Black Onyx UCB</p>
                    </td>
                    <td>
                      <p>4210201364733</p>
                    </td>
                    <td>
                      <p>Oral-B Genius 8200W White CA</p>
                    </td>
                    <td>
                      <p>4210201203179</p>
                    </td>
                  </tr>
                  <template v-for="(item, idx) in newProducts">
                    <tr v-if="idx % 2 === 0" :key="idx">
                      <td>
                        <p>{{ item.name }}</p>
                      </td>
                      <td>
                        <p>{{ item.ean }}</p>
                      </td>
                      <td>
                        <p>
                          {{
                            newProducts[idx + 1]
                              ? newProducts[idx + 1].name
                              : ""
                          }}
                        </p>
                      </td>
                      <td>
                        <p>
                          {{
                            newProducts[idx + 1] ? newProducts[idx + 1].ean : ""
                          }}
                        </p>
                      </td>
                    </tr>
                  </template>
                  <!-- NEW -->
                </tbody>
              </table>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Hvor kan jeg købe de produkter, der deltager i Oral-B
                penge-tilbage-garanti?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Du kan købe salgsfremmende produkterne hos alle nordiske og
                internationale forhandlere. Bemærk venligst, at vi ikke kan
                acceptere private køb og køb på auktioner.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hvor meget vil jeg få refunderet?</p>
            </div>
            <div class="list-item-details">
              <p>
                Du vil få refunderet 100% af den FAKTISKE købspris (minus
                eventuelle rabatter) for det indsendte deltagende produkt.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hvornår kan jeg deltage i Oral-B penge-tilbage-garanti?</p>
            </div>
            <div class="list-item-details">
              <p>
                Perioden for køb af salgsfremmende produkter er fra
                <b>01.07.2025</b> til og med <b>31.08.2026</b> (datoen for
                købsbeviset er relevant her). Fristen for indsendelse af den
                online registreringsformular og upload af købsbeviset er
                <b>30.10.2026</b>.
              </p>
              <p>
                Du skal registrere din kvittering online senest
                <b>60 dage</b> efter købet.
              </p>
              <p>
                Når din online-registrering er blevet bekræftet, har du
                <b>10 dage</b> til at sende produktet sammen med returformularen
                og en kopi af dit købsbevis til et af vores servicecentre.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hvor ofte kan jeg deltage i Oral-B penge-tilbage-garanti?</p>
            </div>
            <div class="list-item-details">
              <p>
                <br />Hver person (brugerkonto: kombination af IBAN og
                e-mailadresse) kan deltage i Oral-B penge-tilbage-garanti med
                højst 5 købsbeviser og 5 salgsfremmende produkter.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hvor ofte kan jeg deltage i Oral-B penge-tilbage-garanti?</p>
            </div>
            <div class="list-item-details">
              <p>
                Hver person (brugerkonto: kombination af IBAN og e-mailadresse)
                kan deltage i Oral-B penge-tilbage-garanti med højst 5
                købsbeviser og 5 salgsfremmende produkter.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Hvor mange produkter kan jeg deltage i Oral-B
                penge-tilbage-garanti med?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Der kan udstedes en tilbagebetaling for 5 salgsfremmende
                produkter pr person.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hvor længe skal jeg opbevare købsbeviset?</p>
            </div>
            <div class="list-item-details">
              <p>
                Du bedes opbevare købsbeviset, indtil du modtager
                tilbagebetalingen.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hvad er IBAN, og hvor kan jeg finde det?</p>
            </div>
            <div class="list-item-details">
              <p>
                IBAN står for International Bankkontonummer. Det er en
                internationalt godkendt kode bestående af op til 34 bogstaver og
                tal, som hjælper bankerne med at behandle overførsler i hele
                verden. Du kan normalt finde dit IBAN-nummer øverst til højre på
                dit kontoudtog eller i din netbank. Hvis du ikke kan finde dit
                IBAN-nummer, bør du kunne generere det online via din banks
                netbank eller ved at bruge et IBAN-beregnerværktøj.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hvad er BIC, og hvor kan jeg finde det?</p>
            </div>
            <div class="list-item-details">
              <p>
                BIC står for Bankidentifikationskode. For at sende eller modtage
                penge skal enhver finansiel institution vide, hvor pengene skal
                sendes hen, og BIC er præcis det, der viser det. <br />Du kan
                normalt finde din banks BIC på dine kontoudtog. Hvis du bruger
                netbank, kan du logge ind på din digitale bankkonto for nemt at
                se dit kontoudtog eller kontakte din bank, så de kan give dig
                din BIC.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Min partner og jeg har en fælles IBAN-konto. Kan vi begge
                deltage separat med denne konto i Oral-B penge-tilbage-garanti?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Hvert IBAN kan kun bruges af én bruger i hele kampagneperioden
                (i en fast kombination med e-mail-adresse). En fælles brug
                sammen med en anden deltager er ikke mulig uanset en eventuel
                personlig forbindelse.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hvornår kan jeg forvente at få min tilbagebetaling?</p>
            </div>
            <div class="list-item-details">
              <p>
                Efter en positiv kontrol af din deltagelse vil
                refunderingsbeløbet blive overført til den bankkonto (IBAN), du
                har angivet, inden for højst 6 uger.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Kan jeg deltage i andre kampagner med det samme købsbevis?</p>
            </div>
            <div class="list-item-details">
              <p>
                Et produkt, der allerede har deltaget i en anden kampagne, kan
                kun refunderes for denne kampagne op til den faktiske
                produktpris. Hvis du således modtager 10EUR/100KR eller
                20EUR/200KR i vores Oral-B tilbagebetaling-kampagne, vil det
                tilsvarende beløb blive fratrukket fra din refusion i Penge
                tilbage kampagnen. Et produkt, der refunderes i denne kampagne,
                kan ikke bruges i nogen anden Procter &amp; Gamble-kampagne.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Mit købsbevis indeholder mere end 5 Oral-B salgsfremmende
                produkter. Kan to eller flere personer bruge dette købsbevis?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Generelt kan et købsbevis kun deltage i vores Oral-B
                penge-tilbage-garanti én gang. Hverken omfanget af de
                salgsfremmende produkter, der er anført på købsbeviset, kan
                tages i betragtning, eller et salgsfremmende produkt kan
                overdrages til en anden person.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Jeg har ikke modtaget en bekræftelsesmail efter at have
                gennemført deltagelsesprocessen, hvad nu?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Efter en vellykket registrering har du modtaget en
                bekræftelsesmail med et 10-cifret referencenummer. Tjek også din
                SPAM- eller JUNK-mappe. Hvis du ikke har modtaget et 10-cifret
                referencenummer, bedes du deltage igen via kampagnens websted
                <a href="https://www.oral-b-moneyback.com/dk"
                  >www.oral-b-moneyback.com</a
                >.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Når jeg gennemgår deltagelsesprocessen, går den ned på et
                bestemt tidspunkt. Hvad skal jeg gøre?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Hvis du går i stå under deltagelsesprocessen af tekniske
                årsager, anbefales det - hvis det er muligt - at bruge en anden
                enhed. Du kan f.eks. skifte fra din mobiltelefon til din pc.
                Hvis dette ikke virker, kan du prøve at bruge en anden browser.
                Hvis disse små tips ikke hjælper dig, kan du sende en e-mail til
                vores supportafdeling:
                <a href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >. Giv venligst en præcis beskrivelse af problemet i din e-mail
                - et skærmbillede af det punkt, hvor det ikke længere kan gå,
                ville være perfekt. Andre nyttige oplysninger er, hvilken enhed,
                hvilket operativsystem og hvilken browser du bruger. Vores
                supportteam vil derefter stå til rådighed for dig.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Hvordan kan jeg se, om jeg har gennemført upload-processen for
                købsbeviset?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Så snart du har uploadet dit købsbevis, indtastet dine
                personlige oplysninger og bankoplysninger og bekræftet dine
                oplysninger via en sms-kode, vises en meddelelse på skærmen, der
                bekræfter, at dit forsøg på at deltage er lykkedes, og som viser
                dit personlige referencenummer. Du vil også straks modtage en
                e-mail med en bekræftelse eller et afslag til den e-mailadresse,
                du har angivet.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hvor længe er supportafdelingen tilgængelig?</p>
            </div>
            <div class="list-item-details">
              <p>Vores supportafdeling er tilgængelig indtil 19.12.2026.</p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Min deltagelse er blevet bekræftet, men tilbagebetalingsbeløbet
                er forkert. Hvad kan jeg gøre?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                I din bekræftelses-e-mail finder du en knap, som du kan bruge
                til at anmode om en ny vurdering af din sag, som dog bliver
                ugyldig efter 72 timer. I dette tilfælde skal du kontakte vores
                supportteam via
                <a href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >
                og beskrive din sag i en e-mail. De vil tage sig af dine
                bekymringer der.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Hvor længe har jeg mulighed for at anmode om en ny vurdering af
                min sag?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                En automatisk revurdering ved hjælp af de sendte links kan
                anmodes om inden for 72 timer efter, at e-mailen med bekræftelse
                eller afvisning er sendt. Herefter kan du kun anmode om, at din
                sag behandles igen via vores supportteam (<a
                  href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >). Angiv venligst altid dit referencenummer!<br />Bemærk
                venligst, at denne mulighed også kun er tilgængelig i begrænset
                omfang. Dine data bliver slettet efter tilbagebetaling-kampagnen
                er udløbet, behandling er derfor kun mulig op til 7 uger efter
                fristen - dvs. indtil 19.12.2026. Herefter lukkes
                supportafdelingen, og dine henvendelser kan ikke længere
                behandles.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Mit købsbevis blev afvist, fordi ikke alle data kan ses. Hvilke
                data er der tale om?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                På købsbeviset skal forhandleren (filialen), salgsfremmende
                produktet, salgsfremmende produktets pris, købsbevisets samlede
                beløb, købsbevisets ID-nummer (ikke bankens
                transaktionsnummer-ID), momsen, eventuelle rabatter samt dato og
                klokkeslæt fremgå tydeligt.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Mit købsbevis er meget langt og bliver ikke læsbart, når jeg
                tager et billede. Hvordan kan jeg komme videre?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Send venligst købsbeviset i ét billede, når du registrerer dig
                på vores websted. Hvis du modtager en e-mail med besked om, at
                det ikke er læsbart, skal du sende dit købsbevis opdelt i flere
                billeder til supportteamet
                <a href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >. Du skal sørge for, at bunden af hvert billede er lig med
                toppen af det næste billede. Hele købsbeviset skal således
                sendes i stykker.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Hvorfor blev min deltagelse afvist, selv om jeg har købt de
                korrekte produkter?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Det kan f.eks. være en teknisk fejl, eller det kan være, at dit
                købsbevis ikke er skarpt nok eller overeksponeret.<br />I den
                nederste tredjedel af din e-mail med afslag finder du en knap,
                hvor du kan uploade dit købsbevis igen. Klik på denne knap, og
                du vil automatisk blive omdirigeret til genindlæsning af
                købsbeviset. Du bedes tage et nyt foto af dit købsbevis og
                uploade det igen inden for 72 timer. Bemærk venligst, at knappen
                mister sin funktionalitet efter 72 timer.<br />Hvis din
                deltagelse afvises igen, bedes du kontakte os via
                support-e-mailadressen, som du også kan finde i din e-mail med
                afvisning (<a href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >).
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Mit købsbevis blev ikke accepteret eller blev endda betegnet som
                svindel. Hvordan kan det være?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Hvis dit købsbevis er for sløret eller for mørkt eller
                overbelyst, så dataene ikke kan ses tydeligt, er der en mulighed
                for, at du modtager en e-mail med afvisning, hvori købsbeviset
                beskrives som falsk, eller at du bliver bedt om at uploade et
                billede af bedre kvalitet af dit købsbevis. Hjælp os med at
                acceptere din deltagelse hurtigt og uden komplikationer ved at
                uploade et foto af god kvalitet (ikke en scanning!) af dit
                købsbevis, som viser, at det er en original kvittering, og hvor
                alle de nødvendige data tydeligt kan ses. Du sparer en masse tid
                og besvær for både dig selv og os.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Kan jeg også sende mit købsbevis pr. e-mail?</p>
            </div>
            <div class="list-item-details">
              <p>
                Du kan kun gennemføre online deltagelsesprocessen på vores
                salgsfremmende websted
                <a href="https://www.oral-b-moneyback.com/dk"
                  >www.oral-b-moneyback.com</a
                >. Genindsendelse af købsbeviset kan kun ske via en knap til
                genupload, som du finder i din afvisningsmail. Hvis du ikke har
                modtaget en afvisningsmail eller en bekræftelsesmail, er det et
                tegn på, at din deltagelse ikke lykkedes, og at du skal gennemgå
                deltagelsesprocessen igen.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Jeg indtastede et forkert IBAN ved registreringen. Hvad sker der
                i dette tilfælde?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                HHvis du har indtastet et forkert IBAN-nummer, så overførslen
                ikke kan gennemføres, har du én gang mulighed for at ændre det.
                Du kan kontakte den relevante afdeling pr. e-mail inden
                19.12.2026:
                <a
                  style="color: #b5d096"
                  href="mailto:support@oral-b-moneyback.com"
                  >support@oral-b-moneyback.com</a
                >. Hvis en vellykket overførsel heller ikke kan gennemføres med
                dette IBAN, bortfalder retten til tilbagebetaling. Kontroller
                venligst, at dette IBAN endnu ikke er blevet brugt til en anden
                tilbagebetaling som en del af vores Oral-B
                penge-tilbage-garanti.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Jeg har et generelt spørgsmål om Procter &amp; Gamble
                International Operations SA. Hvem skal jeg tale med?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Du bedes kontakte Procter &amp; Gamble International Operations
                SA via
                <a href="mailto:contactCH.im@pg.com">contactCH.im@pg.com</a>.
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div v-if="locale === 'fi'">
        <h1 class="page-title">FAQ</h1>
        <ul ref="list" class="list">
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Mitä ehtoja minun on täytettävä, jotta voin osallistua Oral-B
                Moneyback -takuu?
              </p>
            </div>
            <div class="list-item-details">
              <ul>
                <li>Vähimmäisikäraja: Sinun on oltava vähintään 18-vuotias.</li>
                <li>
                  Asuinpaikka: Asuinpaikan on oltava Norjassa, Tanskassa,
                  Ruotsissa tai Suomessa.
                </li>
                <li>
                  Pankkiyhteydet: Sinulla on oltava Euroopan maan IBAN-numero.
                </li>
                <li>
                  Sähköpostiosoite: Voit osallistua vain omalla
                  sähköpostiosoitteellasi.
                </li>
              </ul>
              <p>
                Huomautus: Kukin IBAN-tilinumero ja sähköpostiosoite yhdistetään
                käyttäjätiliksi, ja ne voivat osallistua kampanjaan vain yhdellä
                yhdistelmällä.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Miten voin osallistua Oral-B Moneyback -takuu?</p>
            </div>
            <div class="list-item-details">
              <p>
                Voit osallistua vain verkossa - kampanjan verkkosivuston
                <a href="https://www.oral-b-moneyback.com/fi"
                  >www.oral-b-moneyback.com</a
                >
                kautta. Prosessi voidaan kuvata seuraavasti:<br /><br />-
                määritä kampanjatuote,<br />- ota kuva ostotodistuksestasi ja
                lataa se,<br />- lataa kuva Oral-B-tuotteen (sinun on
                varmistettava, että kampanjatuotteen viivakoodi näkyy selvästi),
                <br />- anna pankkitiedot (IBAN), sähköpostiosoite ja muita
                henkilökohtaisia tietoja,<br />- hyväksy osallistumisehdot ja
                tietosuojaselosteet.
              </p>
              <p>
                <br />Kun olet saanut vahvistuksen online-rekisteröinnistäsi,
                sinun on lähetettävä tuote ja sitä vastaava kuponki
                palvelukeskukseen <strong>10 päivän</strong> kuluessa. Saat
                hyvityksesi 6 viikon kuluessa siitä, kun paketti on saapunut ja
                vahvistettu palvelukeskuksessa.
              </p>
              <p>
                <br />Huomautus: Ei ole mahdollista käyttää eri
                sähköpostiosoitteita (käyttäjätilit) per henkilö.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Minne minun pitäisi lähettää paketti tuotteineen?</p>
            </div>
            <div class="list-item-details">
              <p>
                Lähetä tuote yhdessä palautuslomakkeen ja kopion ostotositteesta
                kanssa johonkin P&G seuraavista palvelukeskuksista:<br /><br /><strong
                  >Norja</strong
                >
              </p>
              <p>L.G. Elektro A/S</p>
              <p>Kolstien 4</p>
              <p>5097 Bergen</p>
              <p>Norge</p>
              <p>
                <br /><strong>Ruotsi</strong><br />El &amp; Digital Service
                AB<br />Folkungagatan 144<br />116 30 Stockholm<br />Sverige<br /><br /><strong
                  >Suomi</strong
                ><br />AIDE Europe Oy
              </p>
              <p>Haukilahdenkatu 4</p>
              <p>FI-00550 Helsinki</p>
              <p>Suomi<br /><br /><strong>Tanska</strong></p>
              <p>
                CJ Hvidevareservice<br />Thorndahlsvej 11<br />9200 Aalborg
                SV<br />Danmark
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Keneen otan yhteyttä, jos minulla on kysyttävää Oral-B Moneyback
                -takuu?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Ota yhteyttä <em>Oral-B Moneyback -takuu</em> asiakaspalveluun
                <a href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Mitä tuotteita minun on ostettava voidakseni osallistua Oral-B
                Moneyback -takuu?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Seuraavat tuotteet osallistuvat
                <em>Oral-B Moneyback -takuu</em>:<br /><br />
              </p>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <p>Oral-B Laboratory Clean 1</p>
                    </td>
                    <td>
                      <p>4210201238331</p>
                    </td>
                    <td>
                      <p>Oral-B iO8 S Black UCB</p>
                    </td>
                    <td>
                      <p>4210201307327</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Laboratory Clean 3</p>
                    </td>
                    <td>
                      <p>4210201291947</p>
                    </td>
                    <td>
                      <p>Oral-B iO8 S Violet UC</p>
                    </td>
                    <td>
                      <p>4210201307389</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Laboratory Clean 5</p>
                    </td>
                    <td>
                      <p>4210201238492</p>
                    </td>
                    <td>
                      <p>Oral-B iO9 S White UC</p>
                    </td>
                    <td>
                      <p>4210201307556</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality100 Kids Frozen Hbox + TC</p>
                    </td>
                    <td>
                      <p>4210201309512</p>
                    </td>
                    <td>
                      <p>Oral-B iO9 S Black UCB</p>
                    </td>
                    <td>
                      <p>4210201307594</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality Kids Spiderman CLS</p>
                    </td>
                    <td>
                      <p>4210201320074</p>
                    </td>
                    <td>
                      <p>Oral-B iO9 S Rose Quartz UC</p>
                    </td>
                    <td>
                      <p>4210201307631</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality100 Kids Mandalorian CLS</p>
                    </td>
                    <td>
                      <p>4210201386230</p>
                    </td>
                    <td>
                      <p>Oral-B iO8 Duo White UC / Black UC</p>
                    </td>
                    <td>
                      <p>4210201315766</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality100 Kids Starwars Hbox + TC</p>
                    </td>
                    <td>
                      <p>4210201309444</p>
                    </td>
                    <td>
                      <p>Oral-B iO6 White UC</p>
                    </td>
                    <td>
                      <p>4210201377665</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality100 Kids Star wars CLS</p>
                    </td>
                    <td>
                      <p>4210201241201</p>
                    </td>
                    <td>
                      <p>Oral-B iO6 Grey Opal UC</p>
                    </td>
                    <td>
                      <p>4210201377788</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality100 Kids Frozen CLS</p>
                    </td>
                    <td>
                      <p>4210201241317</p>
                    </td>
                    <td>
                      <p>Oral-B iO6 Pink Sand GC</p>
                    </td>
                    <td>
                      <p>4210201378143</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality100 Kids Starwars Hbox</p>
                    </td>
                    <td>
                      <p>4210201241331</p>
                    </td>
                    <td>
                      <p>Oral-B iO6 Duo White UC / Pink UC</p>
                    </td>
                    <td>
                      <p>4210201378198</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Kids D12 Starter Pack Star Wars</p>
                    </td>
                    <td>
                      <p>4210201307105</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2 2400N Black SUT</p>
                    </td>
                    <td>
                      <p>4210201258117</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Kids D12 Starter Pack Frozen</p>
                    </td>
                    <td>
                      <p>4210201307242</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2 2400N Pink SUT</p>
                    </td>
                    <td>
                      <p>4210201258544</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Starter Pack Turquiose CA</p>
                    </td>
                    <td>
                      <p>4210201260899</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2 2300W White SUT</p>
                    </td>
                    <td>
                      <p>4210201258643</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality100 Kids Frozen Hbox</p>
                    </td>
                    <td>
                      <p>4210201241379</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2 2200S Blue SUT</p>
                    </td>
                    <td>
                      <p>4210201274681</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 680 White CA</p>
                    </td>
                    <td>
                      <p>4210201235811</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2900 Black CA</p>
                    </td>
                    <td>
                      <p>4210201271598</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 3 Junior Star Wars Sens</p>
                    </td>
                    <td>
                      <p>4210201396109</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2700 Blue CA</p>
                    </td>
                    <td>
                      <p>4210201179078</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 3 Junior Minnie Sens</p>
                    </td>
                    <td>
                      <p>4210201396123</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2000 White SUT</p>
                    </td>
                    <td>
                      <p>4210201249924</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3400N Black CA</p>
                    </td>
                    <td>
                      <p>4210201291053</p>
                    </td>
                    <td>
                      <p>Oral-B Pro2 2500 Black CA Black</p>
                    </td>
                    <td>
                      <p>4210201319412</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3400N Pink Sensi</p>
                    </td>
                    <td>
                      <p>4210201291077</p>
                    </td>
                    <td>
                      <p>Oral-B Pro2 2500 Pink 3DW</p>
                    </td>
                    <td>
                      <p>4210201319313</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3200S Blue Sensi</p>
                    </td>
                    <td>
                      <p>4210201291091</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2000 Blue CA</p>
                    </td>
                    <td>
                      <p>4210201178682</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3000 PureClean</p>
                    </td>
                    <td>
                      <p>4210201365280</p>
                    </td>
                    <td>
                      <p>Oral-B Oral B Clean &amp; Protect Pro 2 Black CA</p>
                    </td>
                    <td>
                      <p>4210201396000</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3300W White Sensi</p>
                    </td>
                    <td>
                      <p>4210201291114</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2 2000 Black CA Black</p>
                    </td>
                    <td>
                      <p>4210201267782</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 890 White SUT</p>
                    </td>
                    <td>
                      <p>4210201235941</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2 2000 Pink CA</p>
                    </td>
                    <td>
                      <p>4210201178736</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3900N White Sens +Black Sens</p>
                    </td>
                    <td>
                      <p>4210201291503</p>
                    </td>
                    <td>
                      <p>Oral-B iO 6N Black UCB</p>
                    </td>
                    <td>
                      <p>4210201409113</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3950N Black CA + Pink CA</p>
                    </td>
                    <td>
                      <p>4210201291374</p>
                    </td>
                    <td>
                      <p>Oral-B iO7 N White UC</p>
                    </td>
                    <td>
                      <p>4210201307181</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Smart 4 4900 White SUT</p>
                    </td>
                    <td>
                      <p>4210201271611</p>
                    </td>
                    <td>
                      <p>Oral-B iO8 SE Black UC + Pouch</p>
                    </td>
                    <td>
                      <p>4210201307433</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Genius X 20400N Black CA Black</p>
                    </td>
                    <td>
                      <p>4210201272922</p>
                    </td>
                    <td>
                      <p>Oral-B iO8 SE Violet UC + Pouch</p>
                    </td>
                    <td>
                      <p>4210201307464</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Genius X 20300W White SUT</p>
                    </td>
                    <td>
                      <p>4210201276869</p>
                    </td>
                    <td>
                      <p>Oral-B iO9 N Black UCB</p>
                    </td>
                    <td>
                      <p>4210201307570</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Genius X 20200S RoseGold SUT</p>
                    </td>
                    <td>
                      <p>4210201274858</p>
                    </td>
                    <td>
                      <p>Oral-B iO9 N RoseQuartz UC</p>
                    </td>
                    <td>
                      <p>4210201307617</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality 100 White CA CLS</p>
                    </td>
                    <td>
                      <p>4210201199441</p>
                    </td>
                    <td>
                      <p>Oral-B iO9 N White UC</p>
                    </td>
                    <td>
                      <p>4210201307532</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality 100 White CA HB</p>
                    </td>
                    <td>
                      <p>4210201199472</p>
                    </td>
                    <td>
                      <p>Oral-B iO6 Duo Black UC / Pink UC</p>
                    </td>
                    <td>
                      <p>4210201411536</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality 170 Blue CA HB</p>
                    </td>
                    <td>
                      <p>4210201201038</p>
                    </td>
                    <td>
                      <p>Oral-B iO9 Duo Black UC / Rose Quartz UC</p>
                    </td>
                    <td>
                      <p>4210201411550</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Junior Green SUT</p>
                    </td>
                    <td>
                      <p>4210201202318</p>
                    </td>
                    <td>
                      <p>Oral-B PROFESSIONAL GUM CARE 1</p>
                    </td>
                    <td>
                      <p>4210201238355</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Junior Purple SUT</p>
                    </td>
                    <td>
                      <p>4210201202332</p>
                    </td>
                    <td>
                      <p>Oral-B PROFESSIONAL GUM CARE 2</p>
                    </td>
                    <td>
                      <p>4210201238454</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 760 Black CA</p>
                    </td>
                    <td>
                      <p>4210201137191</p>
                    </td>
                    <td>
                      <p>Oral-B PROFESSIONAL GUM CARE 3</p>
                    </td>
                    <td>
                      <p>4210201238515</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 700 Turquoise CA</p>
                    </td>
                    <td>
                      <p>4210201124092</p>
                    </td>
                    <td>
                      <p>Oral-B PROFESSIONAL GENIUS 10 GUM CARE</p>
                    </td>
                    <td>
                      <p>4210201271864</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 700 White SUT</p>
                    </td>
                    <td>
                      <p>4210201157786</p>
                    </td>
                    <td>
                      <p>Oral-B Vitality100 Kids Pixar Hbox + TC</p>
                    </td>
                    <td>
                      <p>4210201314592</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 750 Black CA Black</p>
                    </td>
                    <td>
                      <p>4210201319399</p>
                    </td>
                    <td>
                      <p>Oral-B Vitality 150 White CA HB</p>
                    </td>
                    <td>
                      <p>4210201200772</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 750 Pink 3DW</p>
                    </td>
                    <td>
                      <p>4210201312499</p>
                    </td>
                    <td>
                      <p>Oral-B Junior D501 Star Wars SUT</p>
                    </td>
                    <td>
                      <p>4210201245780</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro1 750 White CA</p>
                    </td>
                    <td>
                      <p>4210201312291</p>
                    </td>
                    <td>
                      <p>Oral-B Junior D501 Minnie SUT</p>
                    </td>
                    <td>
                      <p>4210201245896</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 800 White SUT</p>
                    </td>
                    <td>
                      <p>4210201077596</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 4 4400N White SUT</p>
                    </td>
                    <td>
                      <p>4210201255277</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 900 White SUT</p>
                    </td>
                    <td>
                      <p>4210201187370</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 4 4200S White CA</p>
                    </td>
                    <td>
                      <p>4210201274728</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3700 CA</p>
                    </td>
                    <td>
                      <p>4210201291176</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 5000N White CA</p>
                    </td>
                    <td>
                      <p>4210201203315</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 3 3000 CA Black Edition</p>
                    </td>
                    <td>
                      <p>4210201289364</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 5 5400N White SUT</p>
                    </td>
                    <td>
                      <p>4210201255499</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3000 White Sensi</p>
                    </td>
                    <td>
                      <p>4210201289470</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 5 5200S White CA</p>
                    </td>
                    <td>
                      <p>4210201274773</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3500 Black CA Black</p>
                    </td>
                    <td>
                      <p>4210201289517</p>
                    </td>
                    <td>
                      <p>Oral-B GENIUS 8 8100S WHITE SU</p>
                    </td>
                    <td>
                      <p>4210201261414</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3500 WT Sensi</p>
                    </td>
                    <td>
                      <p>4210201289562</p>
                    </td>
                    <td>
                      <p>Oral-B Genius X 20100S Blush Pink SUT</p>
                    </td>
                    <td>
                      <p>4210201279785</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 970 White CA</p>
                    </td>
                    <td>
                      <p>4210201207955</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 4 4000N White CA</p>
                    </td>
                    <td>
                      <p>4210201203377</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Smart Sensitive White Sensi</p>
                    </td>
                    <td>
                      <p>4210201396697</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 4 4500 3DW</p>
                    </td>
                    <td>
                      <p>4210201312536</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Smart Sensitive WT Sensi + TC</p>
                    </td>
                    <td>
                      <p>4210201396673</p>
                    </td>
                    <td>
                      <p>Oral-B Genius 8600 Silver SUT</p>
                    </td>
                    <td>
                      <p>4210201261506</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Smart 5 5900 Black + White CA</p>
                    </td>
                    <td>
                      <p>4210201180074</p>
                    </td>
                    <td>
                      <p>Oral-B Genius 8500 Silver CA</p>
                    </td>
                    <td>
                      <p>4210201314530</p>
                    </td>
                  </tr>
                  <tr></tr>
                  <tr>
                    <td>
                      <p>Oral-B Genius X 20100S Black CA BK</p>
                    </td>
                    <td>
                      <p>4210201247357</p>
                    </td>
                    <td>
                      <p>Oral-B Genius 8900 Silver CA + Silver 3DW</p>
                    </td>
                    <td>
                      <p>4210201157601</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Genius X 20900 RoseG SUT/Black CA Black</p>
                    </td>
                    <td>
                      <p>4210201276982</p>
                    </td>
                    <td>
                      <p>Oral-B Genius X 20100S White SUT</p>
                    </td>
                    <td>
                      <p>4210201247166</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality 100 Pink CA HB</p>
                    </td>
                    <td>
                      <p>4210201200710</p>
                    </td>
                    <td>
                      <p>Oral-B Genius X Blush Pink SUT Art of Brushing</p>
                    </td>
                    <td>
                      <p>4210201295358</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality 100 Black CA HB</p>
                    </td>
                    <td>
                      <p>4210201200758</p>
                    </td>
                    <td>
                      <p>Oral-B Genius X Black CA Black Art of Brushing</p>
                    </td>
                    <td>
                      <p>4210201295402</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B iO7 S White UC</p>
                    </td>
                    <td>
                      <p>4210201306702</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 6 6600 Blue CA</p>
                    </td>
                    <td>
                      <p>4210201203292</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B iO7S Black Onyx UCB</p>
                    </td>
                    <td>
                      <p>4210201364733</p>
                    </td>
                    <td>
                      <p>Oral-B Genius 8200W White CA</p>
                    </td>
                    <td>
                      <p>4210201203179</p>
                    </td>
                  </tr>
                  <template v-for="(item, idx) in newProducts">
                    <tr v-if="idx % 2 === 0" :key="idx">
                      <td>
                        <p>{{ item.name }}</p>
                      </td>
                      <td>
                        <p>{{ item.ean }}</p>
                      </td>
                      <td>
                        <p>
                          {{
                            newProducts[idx + 1]
                              ? newProducts[idx + 1].name
                              : ""
                          }}
                        </p>
                      </td>
                      <td>
                        <p>
                          {{
                            newProducts[idx + 1] ? newProducts[idx + 1].ean : ""
                          }}
                        </p>
                      </td>
                    </tr>
                  </template>
                  <!-- NEW -->
                </tbody>
              </table>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Mistä voin ostaa Oral-B Moneyback -takuu osallistuvia tuotteita?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                <br />Voit ostaa kampanjatuotteita kaikista pohjoismaisista ja
                kansainvälisistä jälleenmyyjistä. Huomaathan, että emme voi
                hyväksyä yksityisostoksia tai huutokaupoista tehtyjä ostoksia.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Kuinka paljon saan korvausta?</p>
            </div>
            <div class="list-item-details">
              <p>
                Sinulle korvataan 100% toimitetun osallistuvan tuotteen
                TODELLISESTA ostohinnasta (vähennettynä mahdollisilla
                alennuksilla).
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Milloin voin osallistua Oral-B Moneyback -takuu?</p>
            </div>
            <div class="list-item-details">
              <p>
                <br />Myynninedistämistuotteiden ostoaika on
                <strong>01.07.2025</strong> ja
                <strong>31.08.2026</strong> älisenä aikana (ostotodistuksen
                päivämäärä on tässä yhteydessä merkityksellinen). Määräaika
                sähköisen rekisteröintilomakkeen lähettämiselle ja ostokuitin
                lataamiselle on <b>30.10.2026</b>.
              </p>
              <p>
                Sinun tulisi rekisteröidä kuittisi verkossa
                <strong>60 päivän</strong> kuluessa ostosta.
              </p>
              <p>
                <br />Kun online-rekisteröinti on vahvistettu, sinulla on
                <strong>10 päivää</strong> aikaa lähettää tuote yhdessä
                palautuslomakkeen ja kopion ostotositteesta kanssa johonkin
                palvelukeskuksistamme.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Kuinka usein voin osallistua Oral-B Moneyback -takuu?</p>
            </div>
            <div class="list-item-details">
              <p>
                <br />Kukin henkilö (käyttäjätili: IBAN-tilinumeron ja
                sähköpostiosoitteen ja yhdistelmä) voi osallistua Oral-B
                Moneyback -takuu enintään 5 ostotodistuksella ja 5
                kampanjatuotteella.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Kuinka monella tuotteella voin osallistua Oral-B Moneyback
                -takuu?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                <br />Palautus voidaan myöntää 5 myynninedistämistuotteelle
                henkilöä kohden.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Kuinka kauan minun on säilytettävä ostotodistus?</p>
            </div>
            <div class="list-item-details">
              <p>Säilytä ostotodistus, kunnes saat palautuksen.</p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Mikä on IBAN ja mistä löydän sen?</p>
            </div>
            <div class="list-item-details">
              <p>
                IBAN tarkoittaa kansainvälistä tilinumeroa. Se on enintään 34
                kirjaimesta ja numerosta koostuva kansainvälisesti sovittu
                koodi, joka auttaa pankkeja käsittelemään tilisiirtoja
                kaikkialla maailmassa.<br />
                IBAN-numerosi löydät yleensä pankkitiliotteesi oikeasta
                yläkulmasta tai verkkopankissasi. Jos et löydä IBAN-numeroasi,
                sinun pitäisi pystyä luomaan se verkossa pankkisi
                verkkopankkipalvelun kautta tai käyttämällä
                IBAN-laskentatyökalua.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Mikä on BIC ja mistä löydän sen?</p>
            </div>
            <div class="list-item-details">
              <p>
                BIC on lyhenne sanoista Bank Identifier Code. Rahan lähettämistä
                tai vastaanottamista varten minkä tahansa rahoituslaitoksen on
                tiedettävä, minne rahat lähetetään, ja BIC on juuri se, mikä sen
                osoittaa. <br />
                Löydät pankkisi BIC-koodin yleensä tiliotteistasi. Jos käytät
                verkkopankkia, kirjaudu digitaaliselle pankkitilillesi
                nähdäksesi helposti tiliotteen tai ota yhteyttä pankkiisi, jotta
                se antaa sinulle BIC-koodisi.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Minulla ja kumppanillani on yhteinen IBAN-tili. Voimmeko
                molemmat osallistua erikseen tällä tilillä Oral-B Moneyback
                -takuu?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                <br />Kutakin IBAN-tilinumeroa voi käyttää vain yksi käyttäjä
                koko kampanjan ajan (kiinteässä yhdistelmässä
                sähköpostiosoitteen kanssa). Yhteiskäyttö toisen osallistujan
                kanssa ei ole mahdollista henkilökohtaisesta yhteydestä
                riippumatta.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Milloin voin odottaa hyvitystä?</p>
            </div>
            <div class="list-item-details">
              <p>
                Kun osallistumisesi on tarkastettu, palautusmäärä siirretään
                ilmoittamallesi pankkitilille (IBAN) enintään 6 viikon kuluessa.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Voinko osallistua muihin kampanjoihin samalla ostotodistuksella?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Tuotteesta, joka on jo osallistunut johonkin toiseen kampanjaan,
                voidaan korvata tämän kampanjan osalta vain tuotteen todellinen
                hinta. Jos siis saat 10EUR/100KR tai 20EUR/200KR Oral-B:n rahat
                takaisin kampanjassa, vastaava summa vähennetään palautuksestasi
                Money Back -kampanjassa. Tässä kampanjassa palautettua tuotetta
                ei voi käyttää missään muussa Procter &amp; Gamble -kampanjassa.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Ostotodistukseni sisältää yli 5 Oral-B kampanjatuotetta. Voiko
                tätä ostotodistusta käyttää kaksi tai useampi henkilö?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Yleensä ostotositteella voi osallistua
                <em>Oral-B Moneyback -takuu</em> vain kerran. Ostotodistuksessa
                lueteltujen kampanjatuotteiden laajuutta ei voida ottaa
                huomioon, eikä kampanjatuotetta voi siirtää toiselle henkilölle.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                En ole saanut vahvistussähköpostia osallistumisprosessin
                suorittamisen jälkeen, mitä nyt?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Onnistuneen rekisteröinnin jälkeen olet saanut
                vahvistussähköpostin, jossa on 10-numeroinen viitenumero.
                Tarkista myös SPAM- tai JUNK-kansiosi. Jos et ole saanut
                10-numeroista viitenumeroa, osallistu uudelleen kampanjan
                verkkosivuston
                <a href="https://www.oral-b-moneyback.com/fi"
                  >www.oral-b-moneyback.com</a
                >
                kautta.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Osallistumisprosessia läpikäydessä se kaatuu tietyssä vaiheessa.
                Mitä minun pitäisi tehdä?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Jos osallistumisprosessi jumiutuu teknisistä syistä, on
                suositeltavaa - jos mahdollista - käyttää toista laitetta.
                Vaihda esimerkiksi matkapuhelimesta tietokoneeseen. Jos tämä ei
                onnistu, voit kokeilla käyttää toista selainta. Jos nämä pienet
                vinkit eivät auta sinua, lähetä sähköpostia tukiosastollemme:
                <a href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >. Anna sähköpostissasi tarkka kuvaus ongelmasta - kuvakaappaus
                kohdasta, jossa ei enää voi mennä, olisi täydellinen. Muita
                hyödyllisiä tietoja ovat laite, käyttöjärjestelmä ja selain,
                jota käytät. Tukitiimimme on sitten tukenasi.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Mistä tiedän, olenko suorittanut ostotodisteen latausprosessin
                onnistuneesti?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Heti kun olet ladannut ostotodistuksen, syöttänyt henkilö- ja
                pankkitietosi ja vahvistanut tietosi tekstiviestikoodilla,
                näytölle ilmestyy viesti, jossa vahvistetaan
                osallistumisyrityksesi onnistuminen ja näytetään
                henkilökohtainen viitenumerosi. Saat myös viipymättä vahvistus-
                tai hylkäyssähköpostin antamaasi sähköpostiosoitteeseen.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Kuinka kauan tukipalvelu on käytettävissä?</p>
            </div>
            <div class="list-item-details">
              <p>Tukiosastomme on tavoitettavissa 19.12.2026 asti.</p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Osallistumiseni on vahvistettu, mutta palautuksen määrä on
                virheellinen. Mitä voin tehdä?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Vahvistussähköpostissasi on painike, jonka avulla voit pyytää
                tapauksesi uudelleenarviointia, joka kuitenkin raukeaa 72 tunnin
                kuluttua. Tässä tapauksessa ota yhteyttä tukitiimiimme
                <a href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >
                ja kuvaile tapauksesi sähköpostitse. He hoitavat huolesi siellä.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Kuinka kauan minulla on mahdollisuus pyytää tapaukseni
                uudelleenarviointia?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Automaattista uudelleenarviointia lähetettyjen linkkien avulla
                voi pyytää 72 tunnin kuluessa vahvistus- tai hylkäyssähköpostin
                lähettämisestä. Tämän jälkeen voit pyytää tapauksesi
                uudelleenkäsittelyä vain tukitiimimme kautta (<a
                  href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >). Ilmoita aina viitenumerosi!<br />Huomaa, että tämäkin
                vaihtoehto on käytettävissä vain rajoitetusti. Tietosi
                poistetaan rahapalautuskampanjan päättymisen jälkeen, joten
                käsittely on mahdollista vain 7 viikkoon asti määräajan
                päättymisen jälkeen - eli 19.12.2026 asti. Tämän jälkeen tuki
                suljetaan, eikä tiedustelujasi voida enää käsitellä.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Ostotodistukseni hylättiin, koska kaikki tiedot eivät näy. Mitä
                tietoja tarkoitetaan?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Ostotodistuksessa on oltava selvästi näkyvissä jälleenmyyjä
                (konttori), kampanjatuote, kampanjatuotteen hinta,
                ostotodistuksen loppusumma, ostotodistuksen ID-numero (ei
                pankkitapahtuman numerotunnus), arvonlisävero, mahdolliset
                alennukset sekä päivämäärä ja kellonaika.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Ostotodistukseni on hyvin pitkä, eikä sitä voi lukea, kun otan
                siitä kuvan.<br />Miten voin edetä?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Lähetä ostotodistus yhdessä kuvassa, kun rekisteröidyt
                verkkosivustollamme. Jos saat sähköpostiviestin, jossa
                kerrotaan, että sitä ei voi lukea, lähetä ostotodistus useampaan
                kuvaan jaettuna tukitiimille
                <a
                  style="color: #b5d096"
                  href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >. Varmista, että jokaisen kuvan alareuna vastaa seuraavan kuvan
                yläreunaa. Näin ollen koko ostotodistus on lähetettävä osissa.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Miksi osallistumiseni hylättiin, vaikka ostin oikeat tuotteet?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Kyse voi olla esimerkiksi teknisestä virheestä tai siitä, että
                ostotositteesi ei ole tarpeeksi terävä tai ylivalottunut.<br />Hylkäävän
                sähköpostiviestin alemmassa kolmanneksessa on painike, jolla
                voit ladata ostotodistuksen uudelleen. Napsauta tätä painiketta,
                niin sinut ohjataan automaattisesti ostotodistuksen
                uudelleenladatamiseen. Ota uusi kuva ostotodistuksestasi ja
                ladata se uudelleen 72 tunnin kuluessa. Huomaa, että painike
                menettää toimintakykynsä 72 tunnin jälkeen.<br />Jos
                osallistumisesi hylätään uudelleen, ota meihin yhteyttä
                tukisähköpostiosoitteessa, joka löytyy myös
                hylkäyssähköpostiviestistäsi (<a
                  style="color: #b5d096"
                  href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >).
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Ostotodistustani ei hyväksytty tai se jopa leimattiin
                petokseksi. Miten se voi olla mahdollista?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Jos ostotodistus on liian epätarkka tai liian tumma tai
                ylivalottunut niin, että tiedot eivät näy selvästi, on
                mahdollista, että saat hylkäävän sähköpostiviestin, jossa
                ostotodistus kuvataan väärennökseksi tai sinua pyydetään
                lataamaan ostotodistuksestasi parempilaatuinen kuva. Auta meitä
                hyväksymään osallistumisesi nopeasti ja mutkattomasti lataamalla
                hyvälaatuinen kuva (ei skannaus!) ostotodistuksestasi, josta käy
                ilmi, että se on alkuperäinen kuitti ja josta kaikki tarvittavat
                tiedot näkyvät selvästi. Säästät paljon aikaa ja vaivaa sekä
                itsellesi että meille.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Voinko lähettää ostotodistukseni myös sähköpostitse?</p>
            </div>
            <div class="list-item-details">
              <p>
                Voit suorittaa online-osallistumisprosessin vain
                mainossivustollamme
                <a
                  style="color: #b5d096"
                  href="https://www.oral-b-moneyback.com/fi"
                  >www.oral-b-moneyback.com</a
                >. Ostotodistuksen voi lähettää uudelleen vain uudelleen ladata
                painikkeella, jonka löydät hylkäävästä sähköpostiviestistäsi.
                Jos et ole saanut hylkäyssähköpostia tai vahvistussähköpostia,
                tämä on merkki siitä, että osallistumisesi ei onnistunut ja
                sinun on käytävä osallistumisprosessi läpi uudelleen.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Syötin väärän IBAN-tilinumeron rekisteröitymisen yhteydessä.
                Mitä tässä tapauksessa tapahtuu?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Jos olet syöttänyt väärän IBAN-tilinumeron, joten siirtoa ei
                voida suorittaa, sinulla on kerran mahdollisuus muuttaa se. Voit
                ottaa yhteyttä asianomaiseen osastoon sähköpostitse 19.12.2026
                mennessä:
                <a href="mailto:support@oral-b-moneyback.com"
                  >support@oral-b-moneyback.com</a
                >. Jos siirtoa ei voida tehdä onnistuneesti myöskään tällä
                IBAN-tilinumerolla, oikeus palautukseen raukeaa. Varmista, että
                tätä IBAN-tilinumeroa ei ole vielä käytetty toiseen palautukseen
                osana <em>Oral-B Moneyback -takuu</em>.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Minulla on yleinen kysymys Procter &amp; Gamble International
                Operations. SA. Kenen kanssa minun pitäisi keskustella?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Ota yhteyttä Procter &amp; Gamble International Operations
                SA:han
                <a href="mailto:contactCH.im@pg.com">contactCH.im@pg.com</a>.
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div v-if="locale === 'no'">
        <h1 class="page-title">FAQ</h1>
        <ul ref="list" class="list">
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Hvilke betingelser må jeg oppfylle for å delta i Oral-B pengene
                tilbake-garanti?
              </p>
            </div>
            <div class="list-item-details">
              <ul>
                <li>Minimumsalder: Du må være minst 18 år gammel.</li>
                <li>
                  Bosted: Bosted må være i Norge, Danmark, Sverige og Finland.
                </li>
                <li>
                  Bankdetaljer: Du må ha et IBAN-nummer som tilhører et
                  europeisk land.
                </li>
                <li>
                  E-postadresse: Du kan bare delta med din egen e-postadresse.
                </li>
              </ul>
              <p>
                MERK: Hver IBAN- og e-postadresse kombineres til en brukerkonto
                og kan bare delta i hele kampanjen i én kombinasjon.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hvordan kan jeg delta i Oral-B pengene tilbake-garanti?</p>
            </div>
            <div class="list-item-details">
              <p>
                Du kan delta online - via kampanjenettstedet
                <a href="https://www.oral-b-moneyback.com/no"
                  >www.oral-b-moneyback.com</a
                >. Prosessen kan beskrives som følger:<br /><br />
              </p>
              <ul>
                <li>spesifiser salgsfremmende produktet,</li>
                <li>lage et bilde av kjøpsbeviset ditt og laste det opp,</li>
                <li>
                  last opp et bilde av ditt Oral-B produkt (du må sørge for at
                  strekkoden til salgsfremmende produktet ditt er tydelig
                  synlig),
                </li>
                <li>
                  angi bankdetaljer (IBAN), e-postadresse, ytterligere
                  personopplysninger,
                </li>
                <li>
                  godta vilkår for deltakelse + personvernregler.<br /><br />
                </li>
              </ul>
              <p>
                Etter kundebekreftelsen for din online registrering, må du sende
                produktet sammen med tilsvarende bilag til servicesenteret innen
                <strong>10 dager</strong>. Du vil motta refusjonen innen 6 uker
                etter at pakken ankommer og er bekreftet i servicesenteret.
              </p>
              <p>
                <br />Merk: Det er ikke mulig å bruke forskjellige
                e-postadresser (brukerkontoer) per person.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hvor skal jeg sende pakken med produktet til?</p>
            </div>
            <div class="list-item-details">
              <p>
                Vennligst send produktet sammen med returskjemaet og en kopi av
                kjøpsbeviset ditt til et av følgende P&amp;G servicesentre:<br /><br /><strong
                  >Norge</strong
                ><br />L.G. Elektro A/S
              </p>
              <p>Kolstien 4</p>
              <p>5097 Bergen</p>
              <p>
                Norge<br /><br /><strong>Sverige</strong><br />El &amp; Digital
                Service AB<br />Folkungagatan 144<br />116 30 Stockholm<br />Sverige
              </p>
              <p><br /><strong>Finland</strong></p>
              <p>AIDE Europe Oy</p>
              <p>Haukilahdenkatu 4</p>
              <p>FI-00550 Helsinki</p>
              <p>
                Suomi<br /><br /><strong>Danmark</strong><br />CJ
                Hvidevareservice<br />Thorndahlsvej 11<br />9200 Aalborg SV<br />Danmark
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Hvem kontakter jeg hvis jeg har spørsmål om Oral-B pengene
                tilbake-garanti?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Kontakt <em>Oral-B pengene tilbake-garanti</em> kundeservice via
                <a href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Hvilke produkter må jeg kjøpe for å delta i Oral-B pengene
                tilbake-garanti?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                <br />Følgende produkter deltar i
                <em>Oral-B pengene tilbake-garanti</em>:<br /><br />
              </p>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <p>Oral-B Laboratory Clean 1</p>
                    </td>
                    <td>
                      <p>4210201238331</p>
                    </td>
                    <td>
                      <p>Oral-B iO8 S Black UCB</p>
                    </td>
                    <td>
                      <p>4210201307327</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Laboratory Clean 3</p>
                    </td>
                    <td>
                      <p>4210201291947</p>
                    </td>
                    <td>
                      <p>Oral-B iO8 S Violet UC</p>
                    </td>
                    <td>
                      <p>4210201307389</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Laboratory Clean 5</p>
                    </td>
                    <td>
                      <p>4210201238492</p>
                    </td>
                    <td>
                      <p>Oral-B iO9 S White UC</p>
                    </td>
                    <td>
                      <p>4210201307556</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality100 Kids Frozen Hbox + TC</p>
                    </td>
                    <td>
                      <p>4210201309512</p>
                    </td>
                    <td>
                      <p>Oral-B iO9 S Black UCB</p>
                    </td>
                    <td>
                      <p>4210201307594</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality Kids Spiderman CLS</p>
                    </td>
                    <td>
                      <p>4210201320074</p>
                    </td>
                    <td>
                      <p>Oral-B iO9 S Rose Quartz UC</p>
                    </td>
                    <td>
                      <p>4210201307631</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality100 Kids Mandalorian CLS</p>
                    </td>
                    <td>
                      <p>4210201386230</p>
                    </td>
                    <td>
                      <p>Oral-B iO8 Duo White UC / Black UC</p>
                    </td>
                    <td>
                      <p>4210201315766</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality100 Kids Starwars Hbox + TC</p>
                    </td>
                    <td>
                      <p>4210201309444</p>
                    </td>
                    <td>
                      <p>Oral-B iO6 White UC</p>
                    </td>
                    <td>
                      <p>4210201377665</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality100 Kids Star wars CLS</p>
                    </td>
                    <td>
                      <p>4210201241201</p>
                    </td>
                    <td>
                      <p>Oral-B iO6 Grey Opal UC</p>
                    </td>
                    <td>
                      <p>4210201377788</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality100 Kids Frozen CLS</p>
                    </td>
                    <td>
                      <p>4210201241317</p>
                    </td>
                    <td>
                      <p>Oral-B iO6 Pink Sand GC</p>
                    </td>
                    <td>
                      <p>4210201378143</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality100 Kids Starwars Hbox</p>
                    </td>
                    <td>
                      <p>4210201241331</p>
                    </td>
                    <td>
                      <p>Oral-B iO6 Duo White UC / Pink UC</p>
                    </td>
                    <td>
                      <p>4210201378198</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Kids D12 Starter Pack Star Wars</p>
                    </td>
                    <td>
                      <p>4210201307105</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2 2400N Black SUT</p>
                    </td>
                    <td>
                      <p>4210201258117</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Kids D12 Starter Pack Frozen</p>
                    </td>
                    <td>
                      <p>4210201307242</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2 2400N Pink SUT</p>
                    </td>
                    <td>
                      <p>4210201258544</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Starter Pack Turquiose CA</p>
                    </td>
                    <td>
                      <p>4210201260899</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2 2300W White SUT</p>
                    </td>
                    <td>
                      <p>4210201258643</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality100 Kids Frozen Hbox</p>
                    </td>
                    <td>
                      <p>4210201241379</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2 2200S Blue SUT</p>
                    </td>
                    <td>
                      <p>4210201274681</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 680 White CA</p>
                    </td>
                    <td>
                      <p>4210201235811</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2900 Black CA</p>
                    </td>
                    <td>
                      <p>4210201271598</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 3 Junior Star Wars Sens</p>
                    </td>
                    <td>
                      <p>4210201396109</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2700 Blue CA</p>
                    </td>
                    <td>
                      <p>4210201179078</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 3 Junior Minnie Sens</p>
                    </td>
                    <td>
                      <p>4210201396123</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2000 White SUT</p>
                    </td>
                    <td>
                      <p>4210201249924</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3400N Black CA</p>
                    </td>
                    <td>
                      <p>4210201291053</p>
                    </td>
                    <td>
                      <p>Oral-B Pro2 2500 Black CA Black</p>
                    </td>
                    <td>
                      <p>4210201319412</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3400N Pink Sensi</p>
                    </td>
                    <td>
                      <p>4210201291077</p>
                    </td>
                    <td>
                      <p>Oral-B Pro2 2500 Pink 3DW</p>
                    </td>
                    <td>
                      <p>4210201319313</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3200S Blue Sensi</p>
                    </td>
                    <td>
                      <p>4210201291091</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2000 Blue CA</p>
                    </td>
                    <td>
                      <p>4210201178682</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3000 PureClean</p>
                    </td>
                    <td>
                      <p>4210201365280</p>
                    </td>
                    <td>
                      <p>Oral-B Oral B Clean &amp; Protect Pro 2 Black CA</p>
                    </td>
                    <td>
                      <p>4210201396000</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3300W White Sensi</p>
                    </td>
                    <td>
                      <p>4210201291114</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2 2000 Black CA Black</p>
                    </td>
                    <td>
                      <p>4210201267782</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 890 White SUT</p>
                    </td>
                    <td>
                      <p>4210201235941</p>
                    </td>
                    <td>
                      <p>Oral-B Pro 2 2000 Pink CA</p>
                    </td>
                    <td>
                      <p>4210201178736</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3900N White Sens +Black Sens</p>
                    </td>
                    <td>
                      <p>4210201291503</p>
                    </td>
                    <td>
                      <p>Oral-B iO 6N Black UCB</p>
                    </td>
                    <td>
                      <p>4210201409113</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3950N Black CA + Pink CA</p>
                    </td>
                    <td>
                      <p>4210201291374</p>
                    </td>
                    <td>
                      <p>Oral-B iO7 N White UC</p>
                    </td>
                    <td>
                      <p>4210201307181</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Smart 4 4900 White SUT</p>
                    </td>
                    <td>
                      <p>4210201271611</p>
                    </td>
                    <td>
                      <p>Oral-B iO8 SE Black UC + Pouch</p>
                    </td>
                    <td>
                      <p>4210201307433</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Genius X 20400N Black CA Black</p>
                    </td>
                    <td>
                      <p>4210201272922</p>
                    </td>
                    <td>
                      <p>Oral-B iO8 SE Violet UC + Pouch</p>
                    </td>
                    <td>
                      <p>4210201307464</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Genius X 20300W White SUT</p>
                    </td>
                    <td>
                      <p>4210201276869</p>
                    </td>
                    <td>
                      <p>Oral-B iO9 N Black UCB</p>
                    </td>
                    <td>
                      <p>4210201307570</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Genius X 20200S RoseGold SUT</p>
                    </td>
                    <td>
                      <p>4210201274858</p>
                    </td>
                    <td>
                      <p>Oral-B iO9 N RoseQuartz UC</p>
                    </td>
                    <td>
                      <p>4210201307617</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality 100 White CA CLS</p>
                    </td>
                    <td>
                      <p>4210201199441</p>
                    </td>
                    <td>
                      <p>Oral-B iO9 N White UC</p>
                    </td>
                    <td>
                      <p>4210201307532</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality 100 White CA HB</p>
                    </td>
                    <td>
                      <p>4210201199472</p>
                    </td>
                    <td>
                      <p>Oral-B iO6 Duo Black UC / Pink UC</p>
                    </td>
                    <td>
                      <p>4210201411536</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality 170 Blue CA HB</p>
                    </td>
                    <td>
                      <p>4210201201038</p>
                    </td>
                    <td>
                      <p>Oral-B iO9 Duo Black UC / Rose Quartz UC</p>
                    </td>
                    <td>
                      <p>4210201411550</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Junior Green SUT</p>
                    </td>
                    <td>
                      <p>4210201202318</p>
                    </td>
                    <td>
                      <p>Oral-B PROFESSIONAL GUM CARE 1</p>
                    </td>
                    <td>
                      <p>4210201238355</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Junior Purple SUT</p>
                    </td>
                    <td>
                      <p>4210201202332</p>
                    </td>
                    <td>
                      <p>Oral-B PROFESSIONAL GUM CARE 2</p>
                    </td>
                    <td>
                      <p>4210201238454</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 760 Black CA</p>
                    </td>
                    <td>
                      <p>4210201137191</p>
                    </td>
                    <td>
                      <p>Oral-B PROFESSIONAL GUM CARE 3</p>
                    </td>
                    <td>
                      <p>4210201238515</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 700 Turquoise CA</p>
                    </td>
                    <td>
                      <p>4210201124092</p>
                    </td>
                    <td>
                      <p>Oral-B PROFESSIONAL GENIUS 10 GUM CARE</p>
                    </td>
                    <td>
                      <p>4210201271864</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 700 White SUT</p>
                    </td>
                    <td>
                      <p>4210201157786</p>
                    </td>
                    <td>
                      <p>Oral-B Vitality100 Kids Pixar Hbox + TC</p>
                    </td>
                    <td>
                      <p>4210201314592</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 750 Black CA Black</p>
                    </td>
                    <td>
                      <p>4210201319399</p>
                    </td>
                    <td>
                      <p>Oral-B Vitality 150 White CA HB</p>
                    </td>
                    <td>
                      <p>4210201200772</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 750 Pink 3DW</p>
                    </td>
                    <td>
                      <p>4210201312499</p>
                    </td>
                    <td>
                      <p>Oral-B Junior D501 Star Wars SUT</p>
                    </td>
                    <td>
                      <p>4210201245780</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro1 750 White CA</p>
                    </td>
                    <td>
                      <p>4210201312291</p>
                    </td>
                    <td>
                      <p>Oral-B Junior D501 Minnie SUT</p>
                    </td>
                    <td>
                      <p>4210201245896</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 800 White SUT</p>
                    </td>
                    <td>
                      <p>4210201077596</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 4 4400N White SUT</p>
                    </td>
                    <td>
                      <p>4210201255277</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 900 White SUT</p>
                    </td>
                    <td>
                      <p>4210201187370</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 4 4200S White CA</p>
                    </td>
                    <td>
                      <p>4210201274728</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3700 CA</p>
                    </td>
                    <td>
                      <p>4210201291176</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 5000N White CA</p>
                    </td>
                    <td>
                      <p>4210201203315</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 3 3000 CA Black Edition</p>
                    </td>
                    <td>
                      <p>4210201289364</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 5 5400N White SUT</p>
                    </td>
                    <td>
                      <p>4210201255499</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3000 White Sensi</p>
                    </td>
                    <td>
                      <p>4210201289470</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 5 5200S White CA</p>
                    </td>
                    <td>
                      <p>4210201274773</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3500 Black CA Black</p>
                    </td>
                    <td>
                      <p>4210201289517</p>
                    </td>
                    <td>
                      <p>Oral-B GENIUS 8 8100S WHITE SU</p>
                    </td>
                    <td>
                      <p>4210201261414</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro3 3500 WT Sensi</p>
                    </td>
                    <td>
                      <p>4210201289562</p>
                    </td>
                    <td>
                      <p>Oral-B Genius X 20100S Blush Pink SUT</p>
                    </td>
                    <td>
                      <p>4210201279785</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Pro 1 970 White CA</p>
                    </td>
                    <td>
                      <p>4210201207955</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 4 4000N White CA</p>
                    </td>
                    <td>
                      <p>4210201203377</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Smart Sensitive White Sensi</p>
                    </td>
                    <td>
                      <p>4210201396697</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 4 4500 3DW</p>
                    </td>
                    <td>
                      <p>4210201312536</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Smart Sensitive WT Sensi + TC</p>
                    </td>
                    <td>
                      <p>4210201396673</p>
                    </td>
                    <td>
                      <p>Oral-B Genius 8600 Silver SUT</p>
                    </td>
                    <td>
                      <p>4210201261506</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Smart 5 5900 Black + White CA</p>
                    </td>
                    <td>
                      <p>4210201180074</p>
                    </td>
                    <td>
                      <p>Oral-B Genius 8500 Silver CA</p>
                    </td>
                    <td>
                      <p>4210201314530</p>
                    </td>
                  </tr>
                  <tr></tr>
                  <tr>
                    <td>
                      <p>Oral-B Genius X 20100S Black CA BK</p>
                    </td>
                    <td>
                      <p>4210201247357</p>
                    </td>
                    <td>
                      <p>Oral-B Genius 8900 Silver CA + Silver 3DW</p>
                    </td>
                    <td>
                      <p>4210201157601</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Genius X 20900 RoseG SUT/Black CA Black</p>
                    </td>
                    <td>
                      <p>4210201276982</p>
                    </td>
                    <td>
                      <p>Oral-B Genius X 20100S White SUT</p>
                    </td>
                    <td>
                      <p>4210201247166</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality 100 Pink CA HB</p>
                    </td>
                    <td>
                      <p>4210201200710</p>
                    </td>
                    <td>
                      <p>Oral-B Genius X Blush Pink SUT Art of Brushing</p>
                    </td>
                    <td>
                      <p>4210201295358</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B Vitality 100 Black CA HB</p>
                    </td>
                    <td>
                      <p>4210201200758</p>
                    </td>
                    <td>
                      <p>Oral-B Genius X Black CA Black Art of Brushing</p>
                    </td>
                    <td>
                      <p>4210201295402</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B iO7 S White UC</p>
                    </td>
                    <td>
                      <p>4210201306702</p>
                    </td>
                    <td>
                      <p>Oral-B Smart 6 6600 Blue CA</p>
                    </td>
                    <td>
                      <p>4210201203292</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>Oral-B iO7S Black Onyx UCB</p>
                    </td>
                    <td>
                      <p>4210201364733</p>
                    </td>
                    <td>
                      <p>Oral-B Genius 8200W White CA</p>
                    </td>
                    <td>
                      <p>4210201203179</p>
                    </td>
                  </tr>
                  <template v-for="(item, idx) in newProducts">
                    <tr v-if="idx % 2 === 0" :key="idx">
                      <td>
                        <p>{{ item.name }}</p>
                      </td>
                      <td>
                        <p>{{ item.ean }}</p>
                      </td>
                      <td>
                        <p>
                          {{
                            newProducts[idx + 1]
                              ? newProducts[idx + 1].name
                              : ""
                          }}
                        </p>
                      </td>
                      <td>
                        <p>
                          {{
                            newProducts[idx + 1] ? newProducts[idx + 1].ean : ""
                          }}
                        </p>
                      </td>
                    </tr>
                  </template>
                  <!-- NEW -->
                </tbody>
              </table>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Hvor kan jeg kjøpe produktene som deltar i Oral-B pengene
                tilbake-garanti?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Du kan kjøpe salgsfremmende produkter fra alle nordiske og
                internasjonale forhandlere. Vær oppmerksom på at vi ikke kan
                akseptere private kjøp og kjøp gjort på auksjoner.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hvor mye får jeg refundert?</p>
            </div>
            <div class="list-item-details">
              <p>
                Du får refundert 100% av den FAKTISKE kjøpesummen som er betalt
                (minus eventuelle rabatter) for det deltakende produktet som er
                sendt inn.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Når kan jeg delta i Oral-B pengene tilbake-garanti?</p>
            </div>
            <div class="list-item-details">
              <p>
                <br />Perioden for kjøp av salgsfremmende produkter er fra
                <strong>01.07.2025 </strong>til og med
                <strong>31.08.2026</strong> (kjøpsdatoen er relevant her).
                Fristen for å sende inn det elektroniske registreringsskjemaet
                og laste opp kjøpskvitteringen er <b>30.10.2026</b>.<br /><br />
              </p>
              <p>
                Du bør registrere kvitteringen din på nettet innen
                <strong>60 dager</strong> etter kjøpet. <br /><br />Etter at din
                online registrering ble bekreftet, vil du ha
                <strong>10 dager</strong> til å sende produktet sammen med
                returskjemaet og en kopi av kjøpsbeviset ditt til et av våre
                servicesentre.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hvor ofte kan jeg delta i Oral-B pengene tilbake-garanti?</p>
            </div>
            <div class="list-item-details">
              <p>
                <br />Hver person (brukerkonto: kombinasjon av IBAN og
                e-postadresse) kan delta i
                <em>Oral-B pengene tilbake-garanti</em> med maksimalt 5
                kjøpsbevis og 5 salgsfremmende produkter.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Hvor mange produkter kan jeg delta i Oral-B pengene
                tilbake-garanti med?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                En refusjon kan utstedes for 5 salgsfremmende produkter per
                person.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hvor lenge må jeg beholde kjøpsbeviset?</p>
            </div>
            <div class="list-item-details">
              <p>Vennligst behold kjøpsbeviset til fordring av refusjonen.</p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hva er IBAN, og hvor finner jeg det?</p>
            </div>
            <div class="list-item-details">
              <p>
                IBAN står for Internasjonalt Bankkontonummer. Det er en
                internasjonalt avtalt kode bestående av opptil 34 bokstaver og
                tall som hjelper banker med å behandle overføringer over hele
                verden. <br />
                Du kan vanligvis finne IBAN-nummeret ditt øverst til høyre på
                kontoutskriften din eller i nettbanken din. Hvis du ikke finner
                IBAN-en din, bør du kunne generere den på nettet via bankens
                nettbanktjeneste eller ved å bruke et IBAN-kalkulatorverktøy.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hva er BIC og hvor finner jeg det?</p>
            </div>
            <div class="list-item-details">
              <p>
                BIC står for Bankens Identifiseringskode. For å sende eller
                motta penger, må enhver finansinstitusjon vite hvor pengene skal
                sendes, og BIC er akkurat det som viser det.
              </p>
              <p>
                Du kan vanligvis finne bankens BIC i kontoutskriftene dine. Hvis
                du bruker nettbank, kan du logge inn på din digitale bankkonto
                for enkelt å se kontoutskriften din eller kontakte banken din
                slik at de gir deg din BIC.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Partneren min og jeg har en felles IBAN-konto. Kan vi begge
                delta separat med denne kontoen i Oral-B pengene
                tilbake-garanti?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                <br />Hver IBAN kan bare brukes av én bruker i hele
                kampanjeperioden (i en fast kombinasjon med e-postadresse). En
                felles bruk med en annen deltaker er ikke mulig uavhengig av
                personlig tilkobling.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Når kan jeg forvente refusjonen min?</p>
            </div>
            <div class="list-item-details">
              <p>
                <br />Etter en positiv sjekk av deltakelsen din, vil
                refusjonsbeløpet bli overført til bankkontoen (IBAN) du
                spesifiserte innen maksimalt 6 uker.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Kan jeg delta i andre kampanjer med samme kjøpsbevis?</p>
            </div>
            <div class="list-item-details">
              <p>
                Et produkt som allerede har deltatt i en annen kampanje, kan
                bare refunderes for denne kampanjen frem til den faktiske
                produktprisen. Dermed, hvis du mottar 10EUR /100KR eller
                20EUR/200KR i vår Oral-B refusjon kampanje, vil det tilsvarende
                beløpet bli trukket fra refusjonen din i Pengene
                Tilbake-kampanjen. Et produkt som refunderes i denne kampanjen,
                kan ikke brukes i noen annen Procter &amp;Gamble-kampanje.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Kjøpsbeviset inneholder mer enn 5 Oral-B salgsfremmende
                produkter. Kan to eller flere personer bruke dette kjøpsbeviset?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Vanligvis kan et kjøpsbevis bare delta i
                <em>Oral-B pengene tilbake-garanti</em> én gang. Verken omfanget
                av salgsfremmende produktene som er oppført på kjøpskvitteringen
                kan tas i betraktning, og heller ikke et salgsfremmende produkt
                kan overføres til en annen person.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Jeg har ikke mottatt en e-postbekreftelse etter å ha fullført
                deltakelsesprosessen, hva nå?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Etter en vellykket registrering vil du ha mottatt en
                bekreftelses-e-post med et 10-sifret referansenummer. Sjekk også
                SPAM- eller JUNK-mappen din. Hvis du ikke har mottatt et
                10-sifret referansenummer, kan du delta på nytt via
                kampanjenettstedet
                <a href="https://www.oral-b-moneyback.com/no"
                  >www.oral-b-moneyback.com</a
                >.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Når du går gjennom deltakelsesprosessen, krasjer den på et
                bestemt tidspunkt. Hva skal jeg gjøre?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Hvis du blir sittende fast under deltakelsesprosessen av
                tekniske årsaker, anbefales det - om mulig - å bruke en annen
                enhet. Du kan for eksempel bytte fra mobiltelefonen til PCen.
                Hvis dette ikke fungerer, kan du prøve å bruke en annen
                nettleser. Hvis disse små tipsene ikke hjelper deg, kan du sende
                en e-post til vår supportavdeling:
                <a href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >. Vennligst gi en presis beskrivelse av problemet i e-posten
                din - et skjermbilde av punktet der det ikke lenger kan gå,
                ville være perfekt. Andre nyttige data er hvilken enhet, hvilket
                operativsystem og hvilken nettleser du bruker. Vårt supportteam
                vil da være ved din side.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Hvordan vet jeg om jeg har fullført opplastingsprosessen for
                kjøpsbevis?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Så snart du har lastet opp kjøpsbeviset ditt og skrevet inn dine
                personlige opplysninger, vises en melding på skjermen som
                bekrefter hvor vellykket forsøket ditt er på å delta og vise
                ditt personlige referansenummer. Du vil også umiddelbart motta
                en bekreftelses- eller avvisnings-e-post til e-postadressen du
                oppga.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hvor lenge er støtteavdelingen tilgjengelig?</p>
            </div>
            <div class="list-item-details">
              <p>Vår støtteavdeling er tilgjengelig frem til 19.12.2026.</p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Min deltakelse er bekreftet, men refusjonsbeløpet er feil. Hva
                kan jeg gjøre?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                I bekreftelses-e-posten finner du en knapp som du kan be om en
                ny vurdering av saken din med, som imidlertid blir ugyldig etter
                72 timer. I dette tilfellet kan du kontakte supportteamet vårt
                via
                <a href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >
                og beskrive saken din i en e-post. De vil ta seg av dine
                bekymringer der.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Hvor lenge har jeg mulighet til å be om en ny vurdering av saken
                min?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                En automatisk reevaluering ved hjelp av lenkene som sendes kan
                bes om innen 72 timer etter at bekreftelsen eller
                avvisnings-e-posten er sendt. Etter det kan du bare be om at
                saken din behandles på nytt via supportteamet vårt (<a
                  href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >). Oppgi alltid referansenummeret ditt!<br />Vær oppmerksom på
                at dette alternativet også bare er tilgjengelig i begrenset
                grad. Dataene dine vil bli slettet etter at refusjon-kampanjen
                er utløpt, behandlingen er derfor bare mulig til 19.12.2026.
                Støtteavdelingen vil da bli stengt og dine henvendelser kan ikke
                lenger behandles.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Kjøpsbeviset mitt ble avvist fordi ikke alle dataene kan ses.
                Hvilke data er ment?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                På kjøpsbeviset, forhandleren (grenen), kampanjeproduktet,
                prisen på kampanjeproduktet, totalen av kjøpsbeviset, bevis på
                kjøps-ID-nummer (ikke banktransaksjonsnummer-ID), mva,
                eventuelle rabatter som kan gjelde, samt dato og klokkeslett må
                være tydelig synlig.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Kjøpsbeviset mitt er veldig langt og blir ikke lesbart når jeg
                tar et bilde.<br />Hvordan kan jeg fortsette?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Vennligst send kjøpsbeviset på ett bilde når du registrerer deg
                på vår hjemmeside. Hvis du mottar en e-postmelding om at den
                ikke er lesbar, sender du kjøpsbeviset atskilt med flere bilder
                til kundestøtteteamet
                <a href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >. Du må kontrollere at bunnen av hvert bilde er lik toppen av
                neste bilde. Dermed må hele kjøpsbeviset sendes i stykker.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Hvorfor ble min deltakelse avvist selv om jeg kjøpte de riktige
                produktene?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Det kan for eksempel være en teknisk feil, eller det kan være at
                kjøpsbeviset ditt ikke er skarpt nok eller overeksponert.
                <br />I den nedre tredjedelen av avvisnings-e-posten finner du
                en knapp for å laste opp kjøpsbeviset på nytt. Klikk på denne
                knappen, så blir du automatisk omdirigert til re-opplasting av
                kjøpsbeviset. Ta et nytt bilde av kjøpsbeviset og last det opp
                på nytt innen 72 timer. Vær oppmerksom på at knappen mister
                funksjonaliteten etter 72 timer. <br />Hvis deltakelsen din blir
                avvist på nytt, kan du kontakte oss via e-postadressen for
                kundestøtte, som også finnes i avvisnings-e-posten din (<a
                  href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >).
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Kjøpsbeviset mitt ble ikke akseptert eller ble til og med merket
                som svindel. Hvordan kan det være?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Hvis kjøpsbeviset ditt er for uskarpt eller for mørkt eller
                overeksponert slik at dataene ikke kan sees tydelig, er det en
                mulighet for at du vil motta en avvisnings-e-post der
                kjøpsbeviset beskrives som en falsk, eller du blir bedt om å
                laste opp et bedre kvalitetsbilde av kjøpsbeviset ditt. Hjelp
                oss med å akseptere din deltakelse raskt og uten komplikasjoner
                ved å laste opp et bilde av god kvalitet (ikke en skanning!) av
                kjøpsbeviset ditt, som viser at det er en original kvittering og
                som alle nødvendige data tydelig kan ses på. Du sparer mye tid
                og problemer for både deg selv og oss.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Kan jeg også sende inn kjøpsbeviset mitt via e-post?</p>
            </div>
            <div class="list-item-details">
              <p>
                Du kan bare fullføre online deltakelsesprosessen på
                kampanjenettstedet vårt
                <a
                  style="color: #b5d096"
                  href="https://www.oral-b-moneyback.com/no"
                  >www.oral-b-moneyback.com</a
                >. Gjeninnsending av kjøpsbevis kan kun gjøres via en
                reuploadknapp, som du finner i avslags-e-posten. Hvis du ikke
                har mottatt en avvisnings-e-post eller en bekreftelses-e-post,
                er dette en indikasjon på at din deltakelse var mislykket og at
                du må gå gjennom deltakelsesprosessen på nytt.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Jeg skrev inn feil IBAN ved registrering. Hva skjer i dette
                tilfellet?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Hvis du har angitt feil IBAN slik at overføringen ikke kan
                utføres, har du én gang mulighet til å endre den. Du kan
                kontakte den relevante avdelingen via e-post ved å 19.12.2026:
                <a href="mailto:support@oral-b-moneyback.com"
                  >support@oral-b-moneyback.com</a
                >. Hvis en vellykket overføring heller ikke kan gjøres med denne
                IBAN-en, utløper retten til refusjon. Kontroller at denne
                IBAN-en ennå ikke er brukt til en ny refusjon som en del av
                <em>Oral-B pengene tilbake-garanti</em>.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Jeg har et generelt spørsmål om Procter &amp; Gamble
                International Operations SA. Hvem skal jeg snakke med?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                <br />Ta kontakt med Procter &amp;Gamble International
                Operations SA via
                <a href="mailto:contactCH.im@pg.com">contactCH.im@pg.com</a>.
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div v-if="locale === 'se'">
        <h1 class="page-title">Vanliga Frågor</h1>
        <ul ref="list" class="list">
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Vilka villkor måste jag uppfylla för att delta i Oral-B
                pengarna-tillbaka-garanti?
              </p>
            </div>
            <div class="list-item-details">
              <ul>
                <li>Minimiålder: Du måste vara minst 18 år.</li>
                <li>
                  Bosättningsort: Du måste vara bosatt i Norge, Danmark, Sverige
                  eller Finland.
                </li>
                <li>
                  Bankuppgifter: Du måste ha ett IBAN-nummer som tillhör ett
                  europeiskt land.
                </li>
                <li>
                  E-postadress: Du kan endast delta med din egen e-postadress.
                </li>
              </ul>
              <p>
                Observera: Varje IBAN och e-postadress kombineras till ett
                användarkonto och kan delta i kampanjen endast i en enda
                kombination.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Hur kan jag delta i Oral-B pengarna-tillbaka-garanti?<br /><br />
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Du kan endast delta online - via kampanjens webbplats
                <a href="https://www.oral-b-moneyback.com/se"
                  >www.oral-b-moneyback.com</a
                >. Processen kan beskrivas på följande sätt:<br /><br />- ange
                reklamprodukten,<br />- ta ett foto av ditt inköpsbevis och
                ladda upp det,<br />- ladda upp ett foto av din Oral-B produkt
                (du måste se till att streckkoden på din reklamprodukt syns
                tydligt), <br />- ange bankuppgifter (IBAN), e-postadress och
                andra personuppgifter,<br />- godkänna villkoren för deltagande
                + sekretesspolicy.
              </p>
              <p>
                <br />När du har fått en bekräftelse på din online-registrering
                måste du skicka produkten tillsammans med motsvarande kupong
                till servicecentret inom <strong>10 dagar</strong>. Du får din
                återbetalning inom 6 veckor efter det att paketet har anlänt och
                bekräftats i servicecentret.
              </p>
              <p>
                <br />Observera: Det är inte möjligt att använda olika
                e-postadresser (användarkonton) per person.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Vart ska jag skicka paketet med produkten?</p>
            </div>
            <div class="list-item-details">
              <p>
                Skicka din produkt tillsammans med returformuläret och en kopia
                av ditt inköpsbevis till ett av följande P&amp;G
                servicecenter:<br /><br /><strong>Norge</strong>
              </p>
              <p>L.G. Elektro A/S</p>
              <p>Kolstien 4</p>
              <p>5097 Bergen</p>
              <p>Norge</p>

              <p><strong>Sverige</strong></p>
              <p>
                El &amp; Digital Service AB<br />Folkungagatan 144<br />116 30
                Stockholm<br />Sverige
              </p>

              <p><strong>Finland</strong></p>
              <p>AIDE Europe Oy</p>
              <p>Haukilahdenkatu 4</p>
              <p>FI-00550 Helsinki</p>
              <p>Suomi<br /><br /></p>
              <p>
                <strong>Danmark</strong><br />CJ Hvidevareservice<br />Thorndahlsvej
                11<br />9200 Aalborg SV<br />Danmark
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Vem ska jag kontakta om jag har frågor om Oral-B
                pengarna-tillbaka-garanti?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Vänligen kontakta Oral-B pengarna-tillbaka-garanti kundtjänst
                via
                <a href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Vilka produkter måste jag köpa för att delta i Oral-B
                pengarna-tillbaka-garanti?
              </p>
            </div>
            <p>
              Följande produkter deltar i Oral-B pengarna-tillbaka-garanti:<br /><br />
            </p>
            <table>
              <tbody>
                <tr>
                  <td>
                    <p>Oral-B Laboratory Clean 1</p>
                  </td>
                  <td>
                    <p>4210201238331</p>
                  </td>
                  <td>
                    <p>Oral-B iO8 S Black UCB</p>
                  </td>
                  <td>
                    <p>4210201307327</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Laboratory Clean 3</p>
                  </td>
                  <td>
                    <p>4210201291947</p>
                  </td>
                  <td>
                    <p>Oral-B iO8 S Violet UC</p>
                  </td>
                  <td>
                    <p>4210201307389</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Laboratory Clean 5</p>
                  </td>
                  <td>
                    <p>4210201238492</p>
                  </td>
                  <td>
                    <p>Oral-B iO9 S White UC</p>
                  </td>
                  <td>
                    <p>4210201307556</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Vitality100 Kids Frozen Hbox + TC</p>
                  </td>
                  <td>
                    <p>4210201309512</p>
                  </td>
                  <td>
                    <p>Oral-B iO9 S Black UCB</p>
                  </td>
                  <td>
                    <p>4210201307594</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Vitality Kids Spiderman CLS</p>
                  </td>
                  <td>
                    <p>4210201320074</p>
                  </td>
                  <td>
                    <p>Oral-B iO9 S Rose Quartz UC</p>
                  </td>
                  <td>
                    <p>4210201307631</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Vitality100 Kids Mandalorian CLS</p>
                  </td>
                  <td>
                    <p>4210201386230</p>
                  </td>
                  <td>
                    <p>Oral-B iO8 Duo White UC / Black UC</p>
                  </td>
                  <td>
                    <p>4210201315766</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Vitality100 Kids Starwars Hbox + TC</p>
                  </td>
                  <td>
                    <p>4210201309444</p>
                  </td>
                  <td>
                    <p>Oral-B iO6 White UC</p>
                  </td>
                  <td>
                    <p>4210201377665</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Vitality100 Kids Star wars CLS</p>
                  </td>
                  <td>
                    <p>4210201241201</p>
                  </td>
                  <td>
                    <p>Oral-B iO6 Grey Opal UC</p>
                  </td>
                  <td>
                    <p>4210201377788</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Vitality100 Kids Frozen CLS</p>
                  </td>
                  <td>
                    <p>4210201241317</p>
                  </td>
                  <td>
                    <p>Oral-B iO6 Pink Sand GC</p>
                  </td>
                  <td>
                    <p>4210201378143</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Vitality100 Kids Starwars Hbox</p>
                  </td>
                  <td>
                    <p>4210201241331</p>
                  </td>
                  <td>
                    <p>Oral-B iO6 Duo White UC / Pink UC</p>
                  </td>
                  <td>
                    <p>4210201378198</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Kids D12 Starter Pack Star Wars</p>
                  </td>
                  <td>
                    <p>4210201307105</p>
                  </td>
                  <td>
                    <p>Oral-B Pro 2 2400N Black SUT</p>
                  </td>
                  <td>
                    <p>4210201258117</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Kids D12 Starter Pack Frozen</p>
                  </td>
                  <td>
                    <p>4210201307242</p>
                  </td>
                  <td>
                    <p>Oral-B Pro 2 2400N Pink SUT</p>
                  </td>
                  <td>
                    <p>4210201258544</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Starter Pack Turquiose CA</p>
                  </td>
                  <td>
                    <p>4210201260899</p>
                  </td>
                  <td>
                    <p>Oral-B Pro 2 2300W White SUT</p>
                  </td>
                  <td>
                    <p>4210201258643</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Vitality100 Kids Frozen Hbox</p>
                  </td>
                  <td>
                    <p>4210201241379</p>
                  </td>
                  <td>
                    <p>Oral-B Pro 2 2200S Blue SUT</p>
                  </td>
                  <td>
                    <p>4210201274681</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro 680 White CA</p>
                  </td>
                  <td>
                    <p>4210201235811</p>
                  </td>
                  <td>
                    <p>Oral-B Pro 2900 Black CA</p>
                  </td>
                  <td>
                    <p>4210201271598</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro 3 Junior Star Wars Sens</p>
                  </td>
                  <td>
                    <p>4210201396109</p>
                  </td>
                  <td>
                    <p>Oral-B Pro 2700 Blue CA</p>
                  </td>
                  <td>
                    <p>4210201179078</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro 3 Junior Minnie Sens</p>
                  </td>
                  <td>
                    <p>4210201396123</p>
                  </td>
                  <td>
                    <p>Oral-B Pro 2000 White SUT</p>
                  </td>
                  <td>
                    <p>4210201249924</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro3 3400N Black CA</p>
                  </td>
                  <td>
                    <p>4210201291053</p>
                  </td>
                  <td>
                    <p>Oral-B Pro2 2500 Black CA Black</p>
                  </td>
                  <td>
                    <p>4210201319412</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro3 3400N Pink Sensi</p>
                  </td>
                  <td>
                    <p>4210201291077</p>
                  </td>
                  <td>
                    <p>Oral-B Pro2 2500 Pink 3DW</p>
                  </td>
                  <td>
                    <p>4210201319313</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro3 3200S Blue Sensi</p>
                  </td>
                  <td>
                    <p>4210201291091</p>
                  </td>
                  <td>
                    <p>Oral-B Pro 2000 Blue CA</p>
                  </td>
                  <td>
                    <p>4210201178682</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro3 3000 PureClean</p>
                  </td>
                  <td>
                    <p>4210201365280</p>
                  </td>
                  <td>
                    <p>Oral-B Oral B Clean &amp; Protect Pro 2 Black CA</p>
                  </td>
                  <td>
                    <p>4210201396000</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro3 3300W White Sensi</p>
                  </td>
                  <td>
                    <p>4210201291114</p>
                  </td>
                  <td>
                    <p>Oral-B Pro 2 2000 Black CA Black</p>
                  </td>
                  <td>
                    <p>4210201267782</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro 890 White SUT</p>
                  </td>
                  <td>
                    <p>4210201235941</p>
                  </td>
                  <td>
                    <p>Oral-B Pro 2 2000 Pink CA</p>
                  </td>
                  <td>
                    <p>4210201178736</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro3 3900N White Sens +Black Sens</p>
                  </td>
                  <td>
                    <p>4210201291503</p>
                  </td>
                  <td>
                    <p>Oral-B iO 6N Black UCB</p>
                  </td>
                  <td>
                    <p>4210201409113</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro3 3950N Black CA + Pink CA</p>
                  </td>
                  <td>
                    <p>4210201291374</p>
                  </td>
                  <td>
                    <p>Oral-B iO7 N White UC</p>
                  </td>
                  <td>
                    <p>4210201307181</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Smart 4 4900 White SUT</p>
                  </td>
                  <td>
                    <p>4210201271611</p>
                  </td>
                  <td>
                    <p>Oral-B iO8 SE Black UC + Pouch</p>
                  </td>
                  <td>
                    <p>4210201307433</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Genius X 20400N Black CA Black</p>
                  </td>
                  <td>
                    <p>4210201272922</p>
                  </td>
                  <td>
                    <p>Oral-B iO8 SE Violet UC + Pouch</p>
                  </td>
                  <td>
                    <p>4210201307464</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Genius X 20300W White SUT</p>
                  </td>
                  <td>
                    <p>4210201276869</p>
                  </td>
                  <td>
                    <p>Oral-B iO9 N Black UCB</p>
                  </td>
                  <td>
                    <p>4210201307570</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Genius X 20200S RoseGold SUT</p>
                  </td>
                  <td>
                    <p>4210201274858</p>
                  </td>
                  <td>
                    <p>Oral-B iO9 N RoseQuartz UC</p>
                  </td>
                  <td>
                    <p>4210201307617</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Vitality 100 White CA CLS</p>
                  </td>
                  <td>
                    <p>4210201199441</p>
                  </td>
                  <td>
                    <p>Oral-B iO9 N White UC</p>
                  </td>
                  <td>
                    <p>4210201307532</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Vitality 100 White CA HB</p>
                  </td>
                  <td>
                    <p>4210201199472</p>
                  </td>
                  <td>
                    <p>Oral-B iO6 Duo Black UC / Pink UC</p>
                  </td>
                  <td>
                    <p>4210201411536</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Vitality 170 Blue CA HB</p>
                  </td>
                  <td>
                    <p>4210201201038</p>
                  </td>
                  <td>
                    <p>Oral-B iO9 Duo Black UC / Rose Quartz UC</p>
                  </td>
                  <td>
                    <p>4210201411550</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Junior Green SUT</p>
                  </td>
                  <td>
                    <p>4210201202318</p>
                  </td>
                  <td>
                    <p>Oral-B PROFESSIONAL GUM CARE 1</p>
                  </td>
                  <td>
                    <p>4210201238355</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Junior Purple SUT</p>
                  </td>
                  <td>
                    <p>4210201202332</p>
                  </td>
                  <td>
                    <p>Oral-B PROFESSIONAL GUM CARE 2</p>
                  </td>
                  <td>
                    <p>4210201238454</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro 1 760 Black CA</p>
                  </td>
                  <td>
                    <p>4210201137191</p>
                  </td>
                  <td>
                    <p>Oral-B PROFESSIONAL GUM CARE 3</p>
                  </td>
                  <td>
                    <p>4210201238515</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro 1 700 Turquoise CA</p>
                  </td>
                  <td>
                    <p>4210201124092</p>
                  </td>
                  <td>
                    <p>Oral-B PROFESSIONAL GENIUS 10 GUM CARE</p>
                  </td>
                  <td>
                    <p>4210201271864</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro 1 700 White SUT</p>
                  </td>
                  <td>
                    <p>4210201157786</p>
                  </td>
                  <td>
                    <p>Oral-B Vitality100 Kids Pixar Hbox + TC</p>
                  </td>
                  <td>
                    <p>4210201314592</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro 1 750 Black CA Black</p>
                  </td>
                  <td>
                    <p>4210201319399</p>
                  </td>
                  <td>
                    <p>Oral-B Vitality 150 White CA HB</p>
                  </td>
                  <td>
                    <p>4210201200772</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro 1 750 Pink 3DW</p>
                  </td>
                  <td>
                    <p>4210201312499</p>
                  </td>
                  <td>
                    <p>Oral-B Junior D501 Star Wars SUT</p>
                  </td>
                  <td>
                    <p>4210201245780</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro1 750 White CA</p>
                  </td>
                  <td>
                    <p>4210201312291</p>
                  </td>
                  <td>
                    <p>Oral-B Junior D501 Minnie SUT</p>
                  </td>
                  <td>
                    <p>4210201245896</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro 1 800 White SUT</p>
                  </td>
                  <td>
                    <p>4210201077596</p>
                  </td>
                  <td>
                    <p>Oral-B Smart 4 4400N White SUT</p>
                  </td>
                  <td>
                    <p>4210201255277</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro 1 900 White SUT</p>
                  </td>
                  <td>
                    <p>4210201187370</p>
                  </td>
                  <td>
                    <p>Oral-B Smart 4 4200S White CA</p>
                  </td>
                  <td>
                    <p>4210201274728</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro3 3700 CA</p>
                  </td>
                  <td>
                    <p>4210201291176</p>
                  </td>
                  <td>
                    <p>Oral-B Smart 5000N White CA</p>
                  </td>
                  <td>
                    <p>4210201203315</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro 3 3000 CA Black Edition</p>
                  </td>
                  <td>
                    <p>4210201289364</p>
                  </td>
                  <td>
                    <p>Oral-B Smart 5 5400N White SUT</p>
                  </td>
                  <td>
                    <p>4210201255499</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro3 3000 White Sensi</p>
                  </td>
                  <td>
                    <p>4210201289470</p>
                  </td>
                  <td>
                    <p>Oral-B Smart 5 5200S White CA</p>
                  </td>
                  <td>
                    <p>4210201274773</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro3 3500 Black CA Black</p>
                  </td>
                  <td>
                    <p>4210201289517</p>
                  </td>
                  <td>
                    <p>Oral-B GENIUS 8 8100S WHITE SU</p>
                  </td>
                  <td>
                    <p>4210201261414</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro3 3500 WT Sensi</p>
                  </td>
                  <td>
                    <p>4210201289562</p>
                  </td>
                  <td>
                    <p>Oral-B Genius X 20100S Blush Pink SUT</p>
                  </td>
                  <td>
                    <p>4210201279785</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Pro 1 970 White CA</p>
                  </td>
                  <td>
                    <p>4210201207955</p>
                  </td>
                  <td>
                    <p>Oral-B Smart 4 4000N White CA</p>
                  </td>
                  <td>
                    <p>4210201203377</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Smart Sensitive White Sensi</p>
                  </td>
                  <td>
                    <p>4210201396697</p>
                  </td>
                  <td>
                    <p>Oral-B Smart 4 4500 3DW</p>
                  </td>
                  <td>
                    <p>4210201312536</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Smart Sensitive WT Sensi + TC</p>
                  </td>
                  <td>
                    <p>4210201396673</p>
                  </td>
                  <td>
                    <p>Oral-B Genius 8600 Silver SUT</p>
                  </td>
                  <td>
                    <p>4210201261506</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Smart 5 5900 Black + White CA</p>
                  </td>
                  <td>
                    <p>4210201180074</p>
                  </td>
                  <td>
                    <p>Oral-B Genius 8500 Silver CA</p>
                  </td>
                  <td>
                    <p>4210201314530</p>
                  </td>
                </tr>
                <tr></tr>
                <tr>
                  <td>
                    <p>Oral-B Genius X 20100S Black CA BK</p>
                  </td>
                  <td>
                    <p>4210201247357</p>
                  </td>
                  <td>
                    <p>Oral-B Genius 8900 Silver CA + Silver 3DW</p>
                  </td>
                  <td>
                    <p>4210201157601</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Genius X 20900 RoseG SUT/Black CA Black</p>
                  </td>
                  <td>
                    <p>4210201276982</p>
                  </td>
                  <td>
                    <p>Oral-B Genius X 20100S White SUT</p>
                  </td>
                  <td>
                    <p>4210201247166</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Vitality 100 Pink CA HB</p>
                  </td>
                  <td>
                    <p>4210201200710</p>
                  </td>
                  <td>
                    <p>Oral-B Genius X Blush Pink SUT Art of Brushing</p>
                  </td>
                  <td>
                    <p>4210201295358</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B Vitality 100 Black CA HB</p>
                  </td>
                  <td>
                    <p>4210201200758</p>
                  </td>
                  <td>
                    <p>Oral-B Genius X Black CA Black Art of Brushing</p>
                  </td>
                  <td>
                    <p>4210201295402</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B iO7 S White UC</p>
                  </td>
                  <td>
                    <p>4210201306702</p>
                  </td>
                  <td>
                    <p>Oral-B Smart 6 6600 Blue CA</p>
                  </td>
                  <td>
                    <p>4210201203292</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>Oral-B iO7S Black Onyx UCB</p>
                  </td>
                  <td>
                    <p>4210201364733</p>
                  </td>
                  <td>
                    <p>Oral-B Genius 8200W White CA</p>
                  </td>
                  <td>
                    <p>4210201203179</p>
                  </td>
                </tr>
                <template v-for="(item, idx) in newProducts">
                  <tr v-if="idx % 2 === 0" :key="idx">
                    <td>
                      <p>{{ item.name }}</p>
                    </td>
                    <td>
                      <p>{{ item.ean }}</p>
                    </td>
                    <td>
                      <p>
                        {{
                          newProducts[idx + 1] ? newProducts[idx + 1].name : ""
                        }}
                      </p>
                    </td>
                    <td>
                      <p>
                        {{
                          newProducts[idx + 1] ? newProducts[idx + 1].ean : ""
                        }}
                      </p>
                    </td>
                  </tr>
                </template>
                <!-- NEW -->
              </tbody>
            </table>
            <div class="list-item-details"></div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Var kan jag köpa de produkter som deltar i Oral-B
                pengarna-tillbaka-garanti?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Du kan köpa kampanjprodukterna från alla nordiska och
                internationella återförsäljare. Observera att vi inte kan
                acceptera privata köp och köp på auktioner.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hur mycket kommer jag att få tillbaka?</p>
            </div>
            <div class="list-item-details">
              <p>
                Du får 100% av det FAKTISKA inköpspriset (minus eventuella
                rabatter) för den inlämnade deltagande produkten.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>När kan jag delta i Oral-B pengarna-tillbaka-garanti?</p>
            </div>
            <div class="list-item-details">
              <p>
                <br />Perioden för köp av reklamprodukter är från
                <strong>01.07.2025</strong> till och med
                <strong>31.08.2026</strong> (datumet för inköpsbeviset är
                relevant här). Tidsfristen för att skicka in den elektroniska
                registreringsblanketten och ladda upp köpekvittot är
                <b>30.10.2026</b>.
              </p>

              <p>
                Du bör registrera ditt kvitto online inom
                <strong>60 dagar</strong> efter köpet. <br /><br />När din
                online-registrering har bekräftats har du
                <strong>10 dagar</strong> på dig att skicka produkten
                tillsammans med returformuläret och en kopia av ditt inköpsbevis
                till ett av våra servicecenter.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hur ofta kan jag delta i Oral-B pengarna-tillbaka-garanti?</p>
            </div>
            <div class="list-item-details">
              <p>
                <br />Varje person (användarkonto: kombination av IBAN och
                e-postadress) kan delta i Oral-B pengarna-tillbaka-garanti med
                högst 5 inköpsbevis och 5 reklamprodukter.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Hur många produkter kan jag delta i Oral-B
                pengarna-tillbaka-garanti med?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                En återbetalning kan utfärdas för 5 reklamprodukter per person.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hur länge måste jag behålla inköpsbeviset?</p>
            </div>
            <div class="list-item-details">
              <p>Behåll inköpsbeviset tills återbetalningen har mottagits.</p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Vad är IBAN och var hittar jag det?</p>
            </div>
            <div class="list-item-details">
              <p>
                IBAN står för Internationellt Bankkontonummer. Det är en
                internationellt överenskommen kod som består av upp till 34
                bokstäver och siffror och som hjälper bankerna att hantera
                överföringar över hela världen. <br />Du hittar vanligtvis ditt
                IBAN-nummer uppe till höger på ditt kontoutdrag eller i din
                internetbank. Om du inte kan hitta ditt IBAN-nummer bör du kunna
                generera det online via din banks internetbank eller genom att
                använda ett IBAN-kalkylatorverktyg.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Vad är BIC och var hittar jag det?</p>
            </div>
            <div class="list-item-details">
              <p>
                BIC står för Bankidentifieringskod. För att skicka eller ta emot
                pengar måste alla finansinstitut veta vart pengarna ska skickas
                och BIC är precis vad som visar det. <br />Du kan vanligtvis
                hitta din banks BIC i dina kontoutdrag. Om du använder
                internetbank kan du logga in på ditt digitala bankkonto för att
                enkelt se ditt kontoutdrag eller kontakta din bank så att de ger
                dig din BIC.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Min partner och jag har ett gemensamt IBAN-konto. Kan vi båda
                delta separat med detta konto i Oral-B
                pengarna-tillbaka-garanti?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                <br />Varje IBAN kan endast användas av en användare under hela
                kampanjperioden (i en fast kombination med e-postadress). En
                gemensam användning med en annan deltagare är inte möjlig
                oavsett eventuell personlig koppling.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>När kan jag förvänta mig min återbetalning?</p>
            </div>
            <div class="list-item-details">
              <p>
                Efter en positiv kontroll av ditt deltagande kommer
                återbetalningsbeloppet att överföras till det bankkonto (IBAN)
                du angett inom högst 6 veckor.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Kan jag delta i andra kampanjer med samma inköpsbevis?</p>
            </div>
            <div class="list-item-details">
              <p>
                En produkt som redan har deltagit i en annan kampanj kan
                ersättas för denna kampanj endast upp till det faktiska
                produktpriset. Om du alltså får 10EUR/100KR eller 20EUR/200KR i
                vår återbetalning-kampanj för Oral-B kommer motsvarande belopp
                att dras av från din återbetalning i kampanjen Pengarna
                tillbaka. En produkt som återbetalas i denna kampanj kan inte
                användas i någon annan kampanj från Procter &amp; Gamble.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Mitt inköpsbevis innehåller mer än 5 Oral-B reklamprodukter. Kan
                två eller fler personer använda detta köpebevis?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Generellt sett kan ett inköpsbevis bara delta i vår Oral-B
                pengarna-tillbaka-garanti en gång. Varken omfattningen av de
                reklamprodukter som anges på inköpskvittot kan beaktas eller så
                kan en reklamprodukt överföras till en annan person.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Jag har inte fått något bekräftelsemail efter att ha slutfört
                deltagandet, vad händer nu?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Efter en lyckad registrering har du fått ett bekräftelsemail med
                ett 10-siffrigt referensnummer. Kontrollera även din SPAM- eller
                JUNK-mapp. Om du inte har fått något 10-siffrigt referensnummer
                kan du delta igen via kampanjens webbplats
                <a href="https://www.oral-b-moneyback.com/se"
                  >www.oral-b-moneyback.com</a
                >.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                När jag går igenom deltagandeprocessen kraschar den vid ett
                visst tillfälle. Vad ska jag göra?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Om du av tekniska skäl fastnar under deltagandet rekommenderas
                det att du - om möjligt - använder en annan enhet. Byt till
                exempel från din mobiltelefon till din dator. Om detta inte
                fungerar kan du försöka använda en annan webbläsare. Om dessa
                små tips inte hjälper dig kan du skicka ett e-postmeddelande
                till vår supportavdelning:
                <a href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >. Ge en exakt beskrivning av problemet i ditt e-postmeddelande
                - en skärmdump av den punkt där det inte längre går skulle vara
                perfekt. Andra användbara uppgifter är vilken enhet, vilket
                operativsystem och vilken webbläsare du använder. Vårt
                supportteam kommer sedan att stå vid din sida.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Hur kan jag se om jag har slutfört uppladdningen av
                inköpsbeviset?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Så snart du har laddat upp ditt inköpsbevis, angett dina person-
                och bankuppgifter och bekräftat dina uppgifter via en sms-kod
                kommer ett meddelande att visas på skärmen som bekräftar att
                ditt försök att delta lyckats och som visar ditt personliga
                referensnummer. Du kommer också omedelbart att få ett
                e-postmeddelande om bekräftelse eller avslag till den
                e-postadress du angett.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>Hur länge är supportavdelningen tillgänglig?</p>
            </div>
            <div class="list-item-details">
              <p>Vår supportavdelning är tillgänglig till 19.12.2026.</p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Mitt deltagande har bekräftats, men återbetalningsbeloppet är
                felaktigt. Vad kan jag göra?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                I ditt e-postmeddelande finns en knapp med vilken du kan begära
                en ny bedömning av ditt ärende, som dock blir ogiltig efter 72
                timmar. Kontakta i så fall vårt supportteam via
                <a href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >
                och beskriv ditt ärende i ett e-postmeddelande. De kommer att ta
                hand om dina problem där.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Hur länge har jag möjlighet att begära en ny bedömning av mitt
                ärende?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                En automatisk omprövning med hjälp av de skickade länkarna kan
                begäras inom 72 timmar efter det att e-postmeddelandet om
                bekräftelse eller avslag har skickats. Därefter kan du endast
                begära att ditt ärende behandlas på nytt via vårt supportteam
                (<a href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >). Ange alltid ditt referensnummer!<br />Observera att även
                detta alternativ endast är tillgängligt i begränsad omfattning.
                Dina uppgifter kommer att raderas efter att återbetalning
                kampanjen har löpt ut, behandling är därför endast möjlig upp
                till 7 veckor efter tidsfristen - dvs. fram till 19.12.2026. Då
                kommer supportavdelningen att stängas och dina förfrågningar kan
                inte längre behandlas.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Mitt inköpsbevis avvisades eftersom alla uppgifter inte kan ses.
                Vilka uppgifter avses?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                På inköpsbeviset måste återförsäljaren (filialen),
                reklamprodukten, priset på reklamprodukten, summan av
                inköpsbeviset, ID-nummer för inköpsbeviset (inte ID-nummer för
                banktransaktion), momsen, eventuella rabatter samt datum och
                klockslag tydligt framgå.
              </p>
            </div>
          </li>
          <li class="list-item-wrapper">
            <div class="number">
              <p>
                Mitt inköpsbevis är mycket långt och blir inte läsbart när jag
                tar en bild.<br />Hur kan jag gå vidare?
              </p>
            </div>
            <div class="list-item-details">
              <p>
                Skicka in köpebeviset i en enda bild när du registrerar dig på
                vår webbplats. Om du får ett e-postmeddelande om att det inte
                går att läsa, skicka ditt inköpsbevis i flera bilder till
                supportteamet
                <a href="mailto:contact@oral-b-moneyback.com"
                  >contact@oral-b-moneyback.com</a
                >. Du måste se till att botten av varje bild motsvarar toppen av
                nästa bild. Hela inköpsbeviset måste alltså skickas i bitar.
              </p>

              <li class="list-item-wrapper">
                <div class="number">
                  <p>
                    Varför avvisades mitt deltagande trots att jag köpte rätt
                    produkter?
                  </p>
                </div>
                <div class="list-item-details">
                  <p>
                    Det kan till exempel handla om ett tekniskt fel, eller så
                    kan det vara så att ditt inköpsbevis inte är tillräckligt
                    skarpt eller överexponerat.<br />I den nedre tredjedelen av
                    ditt e-postmeddelande om avslag hittar du en knapp för att
                    ladda upp ditt inköpsbevis på nytt. Om du klickar på denna
                    knapp kommer du automatiskt att omdirigeras till
                    uppladdningen av köpebeviset. Ta ett nytt foto av ditt
                    inköpsbevis och ladda upp det igen inom 72 timmar. Observera
                    att knappen förlorar sin funktionalitet efter 72 timmar.<br />Om
                    ditt deltagande avvisas igen, vänligen kontakta oss via
                    supportens e-postadress, som också finns i ditt
                    e-postmeddelande om avvisning (<a
                      href="mailto:contact@oral-b-moneyback.com"
                      >contact@oral-b-moneyback.com</a
                    >).
                  </p>
                </div>
              </li>
              <li class="list-item-wrapper">
                <div class="number">
                  <p>
                    Mitt inköpsbevis godkändes inte eller betecknades till och
                    med som bedrägeri. Hur kan det vara möjligt?
                  </p>
                </div>
                <div class="list-item-details">
                  <p>
                    Om ditt inköpsbevis är för suddigt, för mörkt eller
                    överexponerat så att uppgifterna inte kan ses tydligt finns
                    det en möjlighet att du får ett avvisningsmeddelande där
                    inköpsbeviset beskrivs som en förfalskning eller att du
                    ombeds att ladda upp en bild av bättre kvalitet på ditt
                    inköpsbevis. Hjälp oss att godkänna ditt deltagande snabbt
                    och utan komplikationer genom att ladda upp ett foto av god
                    kvalitet (inte en skanning!) av ditt inköpsbevis, som visar
                    att det är ett originalkvitto och där alla nödvändiga
                    uppgifter tydligt kan ses. Du sparar mycket tid och problem
                    för både dig själv och oss.
                  </p>
                </div>
              </li>
              <li class="list-item-wrapper">
                <div class="number">
                  <p>Kan jag också skicka in mitt inköpsbevis via e-post?</p>
                </div>
                <div class="list-item-details">
                  <p>
                    Du kan endast slutföra online-deltagandeprocessen på vår
                    reklamwebbplats
                    <a href="https://www.oral-b-moneyback.com/se"
                      >www.oral-b-moneyback.com</a
                    >. Du kan bara skicka in beviset på köpet på nytt via
                    knappen för att ladda upp det på nytt, som du hittar i ditt
                    e-postmeddelande om avslag. Om du inte har fått något
                    e-postmeddelande om avslag eller bekräftelse är detta ett
                    tecken på att ditt deltagande inte lyckades och att du måste
                    gå igenom deltagandet igen.
                  </p>
                </div>
              </li>
              <li class="list-item-wrapper">
                <div class="number">
                  <p>
                    Jag angav fel IBAN vid registreringen. Vad händer i detta
                    fall?
                  </p>
                </div>
                <div class="list-item-details">
                  <p>
                    Om du har angett ett felaktigt IBAN-nummer så att
                    överföringen inte kan genomföras har du en enda möjlighet
                    att ändra det. Du kan kontakta den berörda avdelningen via
                    e-post senast 19.12.2026:
                    <a
                      style="color: #b5d096"
                      href="mailto:support@oral-b-moneyback.com"
                      >support@oral-b-moneyback.com</a
                    >. Om en lyckad överföring inte heller kan genomföras med
                    detta IBAN upphör rätten till återbetalning. Kontrollera att
                    detta IBAN ännu inte har använts för en annan återbetalning
                    som en del av vår Oral-B pengarna-tillbaka-garanti.
                  </p>
                </div>
              </li>
              <li class="list-item-wrapper">
                <div class="number">
                  <p>
                    Jag har en allmän fråga om Procter &amp; Gamble
                    International Operations SA. Vem ska jag prata med?
                  </p>
                </div>
                <div class="list-item-details">
                  <p>
                    <br />Kontakta Procter &amp; Gamble International Operations
                    SA via
                    <a href="mailto:contactCH.im@pg.com">contactCH.im@pg.com</a
                    >.
                  </p>
                </div>
              </li>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "faq",
  data() {
    return {
      newProducts: [
        {
          name: "Oral-B iO2 Night Black",
          ean: "8700216612272",
        },
        {
          name: "Oral-B iO Laboratory 2 White",
          ean: "8700216615365",
        },
        {
          name: "Oral-B iO2 Forest Green",
          ean: "8700216612364",
        },
        {
          name: "Oral-B iO2 Night Black Limited Edition, Travel Case",
          ean: "8700216610834",
        },
        {
          name: "Oral-B iO2 Calm Pink",
          ean: "8700216612265",
        },
        {
          name: "Oral-B iO2 Duo Night Black/Forest Green",
          ean: "8700216612418",
        },
        {
          name: "Oral-B iO2 Night Black, Travel Case",
          ean: "8700216612159",
        },
        {
          name: "Oral-B iO2 Duo Night Black/Calm Pink",
          ean: "8700216612470",
        },
        {
          name: "Oral-B iO2 Forest Green, Travel Case",
          ean: "8700216612258",
        },
        {
          name: "Oral-B iO3 Matt Black, Travel Case",
          ean: "8006540731536",
        },
        {
          name: "Oral-B iO2 Calm Pink, Travel Case",
          ean: "8700216612210",
        },
        {
          name: "Oral-B iO Laboratory 5 White, Travel Case, 1 extra refill",
          ean: "8700216822121",
        },
        {
          name: "Oral-B iO2 Easy Clean Night Black",
          ean: "8700216627115",
        },
        {
          name: "Oral-B iO Laboratory 6 Black, Travel Case, 1 extra refill",
          ean: "8700216822169",
        },
        {
          name: "Oral-B iO2 Duo Night Black/Calm Pink, 1 Travel Case",
          ean: "8006530016704",
        },
        {
          name: "Oral-B iO2 Kids 6+ Stitch, Travel Case",
          ean: "8700216931564",
        },
        {
          name: "Oral-B iO2 Kids 6+ Stitch",
          ean: "8700216931533",
        },
        {
          name: "Oral-B iO2 Kids 6+ Spiderman",
          ean: "8700216931380",
        },
        {
          name: "Oral-B iO2 Kids 6+ Spiderman, Travel Case",
          ean: "8700216932509",
        },
        {
          name: "Oral-B iO3 Quite White (Whitening Edition), Travel Refill Holder",
          ean: "8006530005241",
        },
        {
          name: "Oral-B iO3 Blush Pink Black, Travel Case",
          ean: "8006530005395",
        },
        {
          name: "Oral-B iO3 Ice Blue, Travel Case",
          ean: "8006530005357",
        },
        {
          name: "Oral-B iO5 Matt Black, Travel Case, Travel Refill Holder",
          ean: "8006530067713",
        },
        {
          name: "Oral-B iO5 Quite White, Travel Case, Travel Refill Holder",
          ean: "8006530068086",
        },
        {
          name: "Oral-B iO5 Blush Pink, Travel Case, Travel Refill Holder",
          ean: "8006530068024",
        },
        {
          name: "Oral-B iO5 Matt Black/Quite White Duo, 1 Travel Case",
          ean: "8006530068130",
        },
        {
          name: "Oral-B iO6 Black Lava, Travel Case, Travel Refill Holder, 1 Extra Refill",
          ean: "8006530067850",
        },
        {
          name: "Oral-B iO6 White, Travel Case, Travel Refill Holder, 1 Extra Refill",
          ean: "8006530067652",
        },
        {
          name: "Oral-B iO6 Grey Opal, Travel Case, Travel Refill Holder, 1 Extra Refill",
          ean: "8006530067805",
        },
        {
          name: "Oral-B iO6 Series Pink Sand Sensitive, Travel Case, Travel Refill Holder, 1 Extra Refill",
          ean: "8006530067461",
        },
        {
          name: "Oral-B iO6 Black Lava/Pink Sand Sensitive Duo, 1 Travel Case, 1 Extra Refill",
          ean: "8006530067508",
        },
        {
          name: "Oral-B iO9 Black Onyx, Charging Travel Case, Travel Refill Holder, 1 Extra Refill",
          ean: "8006530067591",
        },
        {
          name: "Oral-B iO9 White Alabaster, Charging Travel Case, Travel Refill Holder, 1 Extra Refill",
          ean: "8006530067867",
        },
        {
          name: "Oral-B iO9 Rose Quartz, Charging Travel Case, Travel Refill Holder, 1 Extra Refill",
          ean: "8006530067935",
        },
        {
          name: "Oral-B iO9 Sapphire Blue, Charging Travel Case, Travel Refill Holder, 1 Extra Refill",
          ean: "8006530093576",
        },
        {
          name: "Oral-B iO9 Duo Black Onyx/Rose Quartz, 1 Charging Travel Case, 1 Travel Refill Holder, 1 Extra Refill",
          ean: "8006530067997",
        },
        {
          name: "Oral-B iO10 Cosmic Black, Charging Travel Case, Travel Refill Holder",
          ean: "8006530067690",
        },
        {
          name: "Oral-B iO10 Stardust White, Charging Travel Case, Travel Refill Holder",
          ean: "8006530067423",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin: 10px 5px;
}
.page-title {
  width: 100%;
  text-align: center;
  color: var(--brand-color-1);
  font-size: 36px;
  line-height: 40px;
  font-weight: bold;
  margin: 30px;
  @media (max-width: 575px) {
    font-size: 24px;
    line-height: 28px;
  }
}
.list {
  list-style-type: decimal;
  word-break: break-word;
  margin: 10px 4px;
  li.list-item-wrapper::marker {
    font-size: 26px;
    font-weight: bold;
    color: var(--brand-color-1);
  }
  li::marker {
    font-weight: bold;
  }
  li {
    margin-top: 15px;
    margin-bottom: 20px;
  }
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
}
th,
td {
  padding-left: 20px;
  padding-right: 20px;
}
.number {
  color: var(--brand-color-1);
  font-weight: bold;
  font-size: 24px;
  line-height: 20px;
  display: inline;
  margin-right: 5px;
  p {
    display: inline;
  }
}
p {
  margin-bottom: 0;
}
.list-item-wrapper {
  margin-top: 24px;
  margin-right: 5px;
  white-space: initial;
  color: var(--brand-color-1);
  .list-item-details {
    margin-top: 10px;
    text-justify: auto;
    a {
      text-decoration: underline;
    }
  }
}
</style>
